import "./assistant.bc7e6f76.js";


function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire1e6c"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire1e6c"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

var $1f5FT = parcelRequire("1f5FT");

var $cEKee = parcelRequire("cEKee");

var $2q2gk = parcelRequire("2q2gk");
/**
 * Session watch: collect drop-off leads into the CRM immediately instead of
 * waiting for the backend EndWidgetSessions cron's 5-minute idle sweep.
 *
 * Rules:
 *  - Widget bubble closed OR tab hidden for GRACE_MS (15s) → end the session.
 *    Reopening the widget / returning to the tab within the grace cancels it.
 *  - Page unload (pagehide) → end the session immediately via fetch keepalive
 *    (no grace is possible — the page is going away).
 *
 * Only fires when a lead exists for this page load (leadInfo is set), i.e.
 * the visitor actually engaged with the widget. The backend endpoint is a
 * no-op when the session is already ended, and a later step call resets
 * session_ended=false if the visitor resumes — so over-firing is harmless.
 * The 5-minute cron remains the backstop for killed tabs / dead network
 * where no beacon can fire.
 */ const $1e504a102eae1230$var$GRACE_MS = 15000;
let $1e504a102eae1230$var$timer = null;
function $1e504a102eae1230$var$activeLeadId() {
    return (0, $cEKee.leadInfo)?.id || null;
}
function $1e504a102eae1230$var$fire() {
    const id = $1e504a102eae1230$var$activeLeadId();
    if (id) (0, $2q2gk.endLeadSession)(id);
}
function $1e504a102eae1230$var$schedule() {
    if ($1e504a102eae1230$var$timer || !$1e504a102eae1230$var$activeLeadId()) return;
    $1e504a102eae1230$var$timer = setTimeout(()=>{
        $1e504a102eae1230$var$timer = null;
        $1e504a102eae1230$var$fire();
    }, $1e504a102eae1230$var$GRACE_MS);
}
function $1e504a102eae1230$var$cancel() {
    if ($1e504a102eae1230$var$timer) {
        clearTimeout($1e504a102eae1230$var$timer);
        $1e504a102eae1230$var$timer = null;
    }
}
function $1e504a102eae1230$export$fffabf9cbd3c2d70() {
    $1e504a102eae1230$var$schedule();
}
function $1e504a102eae1230$export$6cc41339ab57dfd2() {
    $1e504a102eae1230$var$cancel();
}
function $1e504a102eae1230$export$2c20d2978a5322d6() {
    // Tab hidden/visible. Note: mobile browsers may suspend timers while
    // backgrounded — if the tab never comes back the cron backstop catches it.
    document.addEventListener('visibilitychange', ()=>{
        if (document.visibilityState === 'hidden') $1e504a102eae1230$var$schedule();
        else $1e504a102eae1230$var$cancel();
    });
    // Real page unload (navigation / tab close): no grace possible, beacon now.
    window.addEventListener('pagehide', ()=>{
        $1e504a102eae1230$var$cancel();
        $1e504a102eae1230$var$fire();
    });
}



var $knjAn = parcelRequire("knjAn");

var $4tyfr = parcelRequire("4tyfr");

var $cNdCr = parcelRequire("cNdCr");

var $cIxq8 = parcelRequire("cIxq8");

var $cEKee = parcelRequire("cEKee");

var $lUSOA = parcelRequire("lUSOA");

var $cEKee = parcelRequire("cEKee");
function $315d4aa1c7fc9672$var$isDisplayOption(option) {
    for (const i of (0, $cEKee.webAssistantOptions)){
        if (i === option) return true;
    }
    return false;
}
function $315d4aa1c7fc9672$export$cad72087bded938() {
    const options = document.querySelectorAll('.option');
    for (const i of options)if (!$315d4aa1c7fc9672$var$isDisplayOption(i.getAttribute('id')) && !i?.closest('.allQuestions__content')) i.classList.add('hidden');
}
function $315d4aa1c7fc9672$var$convertToIcon(iconName) {
    let temp = iconName.trim().match(/[A-Z][a-z]+/g);
    let tempRs = temp.map((item)=>{
        return item.toLowerCase();
    });
    return tempRs.join('-');
}
function $315d4aa1c7fc9672$export$6f4c428fe84a2fb6() {
    $315d4aa1c7fc9672$export$cad72087bded938();
    const menuIcons = {
        instant_quote: '<i class="menu-icon ri-file-list-3-line"></i>',
        schedule_consultation: '<i class="menu-icon ri-calendar-check-line"></i>',
        request_consultation: '<i class="menu-icon ri-calendar-check-line"></i>',
        non_surgical_services: '<i class="menu-icon ri-file-list-2-line"></i>',
        text_us: '<i class="menu-icon ri-chat-3-line"></i>',
        see_all_services: '<i class="menu-icon ri-function-line"></i>',
        procedure_eligibility: '<i class="menu-icon ri-checkbox-circle-line"></i>',
        call: '<i class="menu-icon ri-phone-line"></i>',
        book_appointment: '<i class="menu-icon ri-calendar-check-line"></i>',
        ask_a_question: '<i class="menu-icon ri-question-line"></i>',
        /* Custom options link out to a client-owned page and have no key of their own here. */ custom_option: '<i class="menu-icon ri-external-link-line"></i>'
    };
    /* menuIcons has no entry for `custom_option-<id>`, and custom options usually have
       icon = null, so without a fallback this expression is `undefined` and gets
       stringified into the card as a literal "undefined" above the option name. */ function optionIcon(key) {
        if ((0, $cEKee.optionIcons)[key]) return `<i data-feather=${$315d4aa1c7fc9672$var$convertToIcon((0, $cEKee.optionIcons)[key])}></i>`;
        if (menuIcons[key]) return menuIcons[key];
        if (key.includes('custom_option-')) return menuIcons.custom_option;
        return '';
    }
    function checkOption(value, key) {
        let option = optionIcon(key);
        if (key === 'book_appointment') return option += `<div>${value}</div>`;
        else if (key.includes("custom_option-")) {
            let tempOptionId = parseInt(key.split('-')[1]);
            let optObj = (0, $cEKee.form).widget_options.find((item)=>item.id === tempOptionId);
            if (optObj) return option += `
                <a href="${optObj.url}" style="text-decoration: none; color: #333;" target="_blank">
                    ${value}
                </a>
                `;
            return option += ``;
        } else return option += `
            <div>${value}</div>
            `;
    }
    let menu = '';
    const phoneNumbers = (0, $cEKee.form)?.main_phone_number || ((0, $cEKee.form)?.locations?.length === 1 ? (0, $cEKee.form)?.locations[0]?.phone : null) || (0, $cEKee.phoneToCall);
    for (const [key, value] of Object.entries((0, $cEKee.optionNames))){
        /* Skip options with no display name (e.g. deprecated FAQs) to avoid showing "undefined" */ const displayValue = value ?? '';
        if (displayValue === '' && key !== 'call') continue;
        menu += `
            <div class="option" id="${key}">
                ${key === 'call' ? `
                        <a href=${`tel:${phoneNumbers}`}>
                            ${(0, $cEKee.optionIcons)[key] ? `<i data-feather='${$315d4aa1c7fc9672$var$convertToIcon((0, $cEKee.optionIcons)[key])}' class='feather-20'></i>` : menuIcons[key] || ''}
                            ${displayValue}
                        </a>
                    ` : checkOption(displayValue, key)}
            </div>
        `;
    }
    document.querySelector('.mainMenu__container .content__wrapper').insertAdjacentHTML('beforeend', menu);
    feather.replace();
}



var $5xphE = parcelRequire("5xphE");

var $sFKcc = parcelRequire("sFKcc");

var $knjAn = parcelRequire("knjAn");

var $cIxq8 = parcelRequire("cIxq8");

var $cEKee = parcelRequire("cEKee");

var $5Idx5 = parcelRequire("5Idx5");

var $knjAn = parcelRequire("knjAn");

var $cEKee = parcelRequire("cEKee");
class $284e98494345678b$export$32df0841ff5c7eac {
    constructor({ inputId: inputId = 'locationAskAQuestion', parentClass: parentClass = 'askQuestion__container', wrapperClass: wrapperClass = 'locationsDropdown__wrapper', dataForm: dataForm = 'locationAskAQuestion', optionName: optionName = 'locations-dropdown__item', locations: locations = [] }){
        this.inputId = inputId;
        this.parentClass = parentClass;
        this.wrapperClass = wrapperClass;
        this.locations = locations;
        this.dataForm = dataForm;
        this.optionName = optionName;
        this.boundOnDropdownItemClick = this.onDropdownItemClick.bind(this);
        this.init();
    }
    init() {
        if (this.locations.length > 1) this.getDropdownContainer().innerHTML = this.renderDropdown();
        this.populateLocations(this.locations);
        this.attachEventListeners();
    }
    getDropdownContainer() {
        return document.querySelector(`.${this.parentClass} .location__dropdownAskQuestion`);
    }
    renderDropdown() {
        return `
            <div data-form="${this.dataForm}" class="${this.wrapperClass} dropdown form-control">
                <input id="${this.inputId}" autocomplete="off" placeholder="${(0, $knjAn.t)('select_location')}">
                <span class="down arrow"><i class="ri-arrow-down-s-line"></i></span>
                <span class="up arrow"><i class="ri-arrow-up-s-line"></i></span>
                <div class="locationsDropdown__select">
                    <ul class="locations__select"></ul>
                </div>
            </div>
        `;
    }
    getDropdownList() {
        return document.querySelector(`.${this.parentClass} .${this.wrapperClass} .locationsDropdown__select ul`);
    }
    populateLocations(locations) {
        const dropdownList = this.getDropdownList();
        if (!dropdownList) return;
        dropdownList.innerHTML = locations.length ? locations.map(({ id: id, name: name })=>`
                <li class="${this.optionName}" data-location-id="${id}" data-location-name="${name}">
                    ${name}
                </li>`).join('') : `<li class="locations-dropdown__empty">${(0, $knjAn.t)('no_locations_found')}</li>`;
    }
    attachEventListeners() {
        const locationInput = document.querySelector(`.${this.parentClass} #${this.inputId}`);
        const dropdownWrapper = document.querySelector(`.${this.parentClass} .${this.wrapperClass}`);
        if (!locationInput || !dropdownWrapper) return;
        locationInput.addEventListener('click', ()=>this.toggleDropdown());
        document.addEventListener('click', (e)=>this.handleOutsideClick(e));
        locationInput.addEventListener('input', (e)=>this.handleSearch(e));
        this.attachDropdownSelectionListener();
    }
    attachDropdownSelectionListener() {
        const dropdownList = this.getDropdownList();
        if (!dropdownList) return;
        dropdownList.removeEventListener("click", this.boundOnDropdownItemClick);
        dropdownList.addEventListener("click", this.boundOnDropdownItemClick);
    }
    onDropdownItemClick(event) {
        const item = event.target.closest(`.${this.optionName}`);
        if (!item) return;
        const name = item.getAttribute('data-location-name');
        const id = parseInt(item.getAttribute('data-location-id'));
        this.setSelectedLocationId(id);
        const locationInputElement = document.querySelector(`.${this.parentClass} #${this.inputId}`);
        if (locationInputElement) locationInputElement.value = name;
        document.querySelector(`.${this.parentClass} div[data-form="${this.dataForm}"]`)?.classList.remove('invalid');
        document.querySelector(`.${this.parentClass} .${this.wrapperClass}`)?.classList.add('selected');
        this.toggleDropdown(true);
    }
    handleOutsideClick(event) {
        if (event.target.closest(`.${this.wrapperClass}`)) return;
        this.toggleDropdown(true);
        if (!this.getSelectedLocationId()) this.clearSelection();
    }
    handleSearch(event) {
        const searchValue = event.target.value.toLowerCase();
        this.setSelectedLocationId(null);
        const dropdownList = this.getDropdownList();
        if (!dropdownList) return;
        Array.from(dropdownList.children).forEach((item)=>{
            const name = item.getAttribute('data-location-name').toLowerCase();
            item.style.display = name.includes(searchValue) ? '' : 'none';
        });
    }
    toggleDropdown(forceClose = false) {
        const dropdownWrapper = document.querySelector(`.${this.parentClass} .${this.wrapperClass}`);
        if (!dropdownWrapper) return;
        const shouldClose = forceClose || dropdownWrapper.classList.contains('open');
        dropdownWrapper.classList.toggle('open', !shouldClose);
    }
    clearSelection() {
        this.setSelectedLocationId(null);
        const locationInput = document.querySelector(`.${this.parentClass} #${this.inputId}`);
        const dropdownWrapper = document.querySelector(`.${this.parentClass} .${this.wrapperClass}`);
        if (locationInput) locationInput.value = '';
        dropdownWrapper?.classList.remove('selected');
        this.populateLocations(this.locations);
    }
    setSelectedLocationId(id) {
        (0, $cEKee.setSelectedLocationId)(id);
    }
    getSelectedLocationId() {
        return 0, $cEKee.selectedLocationId;
    }
}


function $ec621361ff91bff2$export$812c1b6681c8ea84() {
    document.querySelector('.askQuestion__container .phone__selected-code img').setAttribute('src', `${(0, $cEKee.appUrl)}/assets/images/svg/${(0, $cEKee.selectedCountry).toLowerCase()}.svg`);
    document.querySelector('.askQuestion__container .selected-country-code').innerHTML = '+' + (0, $cEKee.selectedCodeNumber);
    document.querySelector('.askQuestion__container .phone__countryCode--select').innerHTML = (0, $5Idx5.loadCountriesCodeDropdown)((0, $cIxq8.SCREEN).ASK_QUESTION);
    // load dropdown select location
    new (0, $284e98494345678b$export$32df0841ff5c7eac)({
        locations: (0, $cEKee.locations)
    });
    // lead source dropdown
    const leadSourceOptions = Array.isArray((0, $cEKee.form)?.appointment_channel?.lead_source_options) ? (0, $cEKee.form).appointment_channel.lead_source_options : [];
    const wrapper = document.querySelector('.lead-source-ask-question__wrapper');
    if (wrapper) {
        wrapper.innerHTML = '';
        if (leadSourceOptions.length > 0) {
            const optVal = (o)=>typeof o === 'string' ? o : o?.value ?? o?.label ?? String(o);
            const optLabel = (o)=>typeof o === 'string' ? o : o?.label ?? o?.value ?? String(o);
            wrapper.innerHTML = `
                <div data-form="sourceAskQuestion" class="form-control">
                    <select id="sourceAskQuestion" name="source" aria-label="${(0, $knjAn.t)('how_did_you_hear')}">
                        <option value="" disabled selected>${(0, $knjAn.t)('how_did_you_hear')}</option>
                        ${leadSourceOptions.map((o)=>`<option value="${optVal(o)}">${optLabel(o)}</option>`).join('')}
                    </select>
                </div>
            `;
        }
    }
}



var $fJdVD = parcelRequire("fJdVD");

var $cEKee = parcelRequire("cEKee");
function $4707e992cabc7e60$export$1ad0e6e0e8e8da5() {
    let list = document.querySelector('.interests__container .interests__list');
    let interestsList = ``;
    for (const i of (0, $cEKee.interests))interestsList = interestsList.concat(`
        <div class="interest" data-interest="${i.value}">
            <span class="interest__name">${i.name}</span>
            <span class="interest__checkbox" data-interest="${i.value}">
                <i class="interest__icon-check ri-check-line"></i>
            </span>
        </div>
        `);
    list.insertAdjacentHTML('beforeend', interestsList);
}



var $knjAn = parcelRequire("knjAn");

var $cbfUF = parcelRequire("cbfUF");

var $cIxq8 = parcelRequire("cIxq8");

var $cEKee = parcelRequire("cEKee");

var $5Idx5 = parcelRequire("5Idx5");

var $6jZoE = parcelRequire("6jZoE");

var $cgStI = parcelRequire("cgStI");

var $d3FqX = parcelRequire("d3FqX");

var $dc3p2 = parcelRequire("dc3p2");
function $1675b659b2b8ee2b$export$f416febee6ad4e0b() {
    const shouldHideProviderSelection = (0, $cEKee.isFlowForCalendar) || (0, $cEKee.appointmentChannelId) && (0, $cEKee.form)?.appointment_channel?.staffs?.length > 1;
    const isCategoryEnabled = (0, $cEKee.form)?.appointment_channel?.enable_category_selection;
    // 'hidden' consult provider mode: remove the provider field entirely. When a
    // default provider is configured the API returns just that one staff, so the
    // preselect block below still assigns it silently; with no default the field
    // is simply omitted and the consult is left unassigned.
    const hideConsultProviderField = ((0, $cEKee.form)?.consult_provider_mode || 'all_bookable') === 'hidden';
    if (((0, $cEKee.providers).length === 1 || (0, $cEKee.staffId)) && !shouldHideProviderSelection) {
        if (0, $cEKee.staffId) {
            (0, $cEKee.setProviderId)(+(0, $cEKee.staffId));
            const provider = (0, $cEKee.providers)?.find((p)=>p.id === +(0, $cEKee.staffId));
            (0, $cEKee.setLocationId)((0, $cbfUF.selectLocation) || provider?.location_ids[0]);
        } else (0, $cEKee.setProviderId)((0, $cEKee.providers)[0].id);
    }
    // Language dropdown
    if ((0, $cEKee.form)?.show_language_dropdown) (0, $6jZoE.loadLanguageDropdown)();
    // Native DOB/gender have two independent drivers:
    //  - calendar prebook flow: the appointment channel's collect_* flags (isPrebookPatientInfo)
    //  - consult REQUEST form: the widget's own show_dob_field / show_gender_field flags
    // (`appointmentChannelId` is only set for URL param or calendar flow, so on a plain
    // consult form only the widget-row flags apply.)
    const isPrebookPatientInfo = (0, $cEKee.appointmentChannelId) && (0, $cEKee.form)?.appointment_channel?.collect_patient_information_first_before_scheduling;
    // DOB and gender are deliberately NOT asked on the prebook patient-info
    // form: asking for them before the visitor has picked anything hurts
    // conversion, so on that flow BOTH drivers (channel `collect_dob` /
    // `collect_gender` and the widget-row `show_dob_field` /
    // `show_gender_field`) are gathered on the verify-info page right before
    // the booking is created instead (see appointmentItemsClickEventHandler).
    // Single-pager split: when the consult REQUEST form is the whole flow and
    // DOB is required, DOB is deferred to its own step AFTER the form submits
    // (lead already captured) instead of rendering inline — see
    // shouldSplitDobStep()/showConsultDobStep() in consultListeners.js.
    if ((0, $cEKee.form)?.show_dob_field && !isPrebookPatientInfo && !(0, $cgStI.shouldSplitDobStep)()) requestAnimationFrame(()=>{
        const host = document.querySelector('.requestConsult__container .dob__consult');
        if (!host || document.getElementById('dobConsult')) return;
        host.classList.remove('hidden');
        host.classList.add('form-control');
        host.setAttribute('data-form', 'dobConsult');
        (0, $d3FqX.renderDobDropdowns)(host, {
            inputId: 'dobConsult',
            idPrefix: 'dob',
            onChange: (0, $cgStI.maybeEnableRequestConsultButton)
        });
    });
    if ((0, $cEKee.form)?.show_gender_field && !isPrebookPatientInfo) requestAnimationFrame(()=>{
        const host = document.querySelector('.requestConsult__container .gender__consult');
        if (!host || document.getElementById('genderConsult')) return;
        host.classList.remove('hidden');
        host.classList.add('form-control');
        host.setAttribute('data-form', 'genderConsult');
        host.innerHTML = `
                <label class="gender-dropdown-label">${(0, $knjAn.t)('gender')}</label>
                <select id="genderConsult" aria-label="${(0, $knjAn.t)('gender')}">
                    <option value="" disabled selected>${(0, $knjAn.t)('select_gender')}</option>
                    <option value="male">${(0, $knjAn.t)('male')}</option>
                    <option value="female">${(0, $knjAn.t)('female')}</option>
                    <option value="other">${(0, $knjAn.t)('other')}</option>
                    <option value="prefer_not_to_say">${(0, $knjAn.t)('prefer_not_to_say')}</option>
                </select>
            `;
        document.getElementById('genderConsult').addEventListener('change', ()=>{
            (0, $cgStI.maybeEnableRequestConsultButton)();
        });
    });
    if ((0, $cEKee.form)?.show_insurance_field && !isPrebookPatientInfo) requestAnimationFrame(()=>{
        const host = document.querySelector('.requestConsult__container .insurance__consult');
        if (!host || document.getElementById('insuranceConsult')) return;
        host.classList.add('form-control');
        host.setAttribute('data-form', 'insuranceConsult');
        host.innerHTML = `
            <input
              id="insuranceConsult"
              name="insurance"
              type="text"
              placeholder="${(0, $knjAn.t)('insurance')}"
              autocomplete="off"
              aria-label="${(0, $knjAn.t)('insurance')}"
            />
          `;
    });
    const consultFields = Array.isArray((0, $cEKee.form)?.consult_request_fields) ? (0, $cEKee.form).consult_request_fields : [];
    const requestForm = document.querySelector('.requestConsult__container form');
    const noteElement = document.querySelector('.requestConsult__container .requestConsult__a2p-consent') || document.querySelector('.requestConsult__container .requestConsult__simple-consent');
    const existingCustomFields = document.querySelector('.requestConsult__container .custom-consult-fields');
    if (existingCustomFields) existingCustomFields.remove();
    // Required lead-source dropdown — rendered only when the channel has
    // `lead_source_options` configured. Each option can be a string or an
    // object {value, label}; value is what gets sent as `leads.source`.
    const leadSourceOptions = Array.isArray((0, $cEKee.form)?.appointment_channel?.lead_source_options) ? (0, $cEKee.form).appointment_channel.lead_source_options : [];
    if (leadSourceOptions.length > 0 && !(0, $cEKee.isFlowForCalendar) && requestForm && noteElement) {
        const existingSource = document.querySelector('.requestConsult__container [data-form="sourceConsult"]');
        if (existingSource) existingSource.remove();
        const optVal = (o)=>typeof o === 'string' ? o : o?.value ?? o?.label ?? String(o);
        const optLabel = (o)=>typeof o === 'string' ? o : o?.label ?? o?.value ?? String(o);
        const sourceContainer = document.createElement('div');
        sourceContainer.className = 'form-control';
        sourceContainer.setAttribute('data-form', 'sourceConsult');
        sourceContainer.innerHTML = `
            <select id="sourceConsult" name="source" aria-label="${(0, $knjAn.t)('how_did_you_hear')}">
                <option value="" disabled selected>${(0, $knjAn.t)('how_did_you_hear')}</option>
                ${leadSourceOptions.map((o)=>`<option value="${optVal(o)}">${optLabel(o)}</option>`).join('')}
            </select>
        `;
        requestForm.insertBefore(sourceContainer, noteElement);
        sourceContainer.querySelector('#sourceConsult').addEventListener('change', ()=>{
            (0, $cgStI.maybeEnableRequestConsultButton)();
        });
    }
    // Only add custom questions inline when ≤2 AND none carries a disqualifier;
    // otherwise they are shown one-per-page after submit (disqualifier fields
    // must be stepped so step/disqualified fires before the consult conversion).
    if (!(0, $cEKee.isFlowForCalendar) && consultFields.length > 0 && !(0, $dc3p2.shouldStepConsultFields)(consultFields) && requestForm && noteElement) {
        const wrapper = document.createElement('div');
        wrapper.className = 'custom-consult-fields';
        consultFields.forEach((field)=>{
            const fieldId = `customField__${field.id}`;
            const label = field.label || field.title || 'Custom field';
            const placeholder = field.placeholder || label;
            const options = field.answers || field.options || [];
            const optVal = (o)=>typeof o === 'string' ? o : o?.value ?? o?.label ?? String(o);
            const container = document.createElement('div');
            container.className = 'form-control';
            container.setAttribute('data-form', fieldId);
            switch(field.type){
                case 'select':
                    {
                        container.classList.add('consult-field--select');
                        const optionsHtml = options.map((o)=>`<option value="${optVal(o)}">${optVal(o)}</option>`).join('');
                        container.innerHTML = `
                        <label class="consult-inline-label" for="${fieldId}">${label}</label>
                        <select id="${fieldId}" name="${fieldId}" aria-label="${label}">
                            <option value="" disabled selected>${(0, $knjAn.t)('select_an_option')}</option>
                            ${optionsHtml}
                        </select>
                    `;
                        break;
                    }
                case 'textarea':
                    container.innerHTML = `
                        <textarea id="${fieldId}" name="${fieldId}" placeholder="${placeholder}" aria-label="${label}" rows="3"></textarea>
                    `;
                    break;
                case 'number':
                    container.innerHTML = `
                        <input id="${fieldId}" name="${fieldId}" type="number" min="0" placeholder="${placeholder}" aria-label="${label}" />
                    `;
                    break;
                case 'date':
                    container.innerHTML = `
                        <input id="${fieldId}" name="${fieldId}" type="text" class="dateQuestion--input consult-inline-date" placeholder="${placeholder}" readonly aria-label="${label}" />
                    `;
                    break;
                case 'checkbox':
                    container.classList.add('consult-field--checkbox');
                    container.innerHTML = `
                        <label class="consult-inline-label">${label}</label>
                        <div class="consult-inline-boolean-group">
                            <label class="consult-boolean-option" data-value="yes">
                                <input type="radio" name="${fieldId}_radio" value="yes" id="${fieldId}_yes" aria-label="${(0, $knjAn.t)('yes')}">
                                ${(0, $knjAn.t)('yes')}
                            </label>
                            <label class="consult-boolean-option" data-value="no">
                                <input type="radio" name="${fieldId}_radio" value="no" id="${fieldId}_no" aria-label="${(0, $knjAn.t)('no')}">
                                ${(0, $knjAn.t)('no')}
                            </label>
                        </div>
                        <input type="hidden" id="${fieldId}" name="${fieldId}" value="" />
                    `;
                    break;
                case 'multi_select':
                    {
                        const optionsList = options.map((o)=>{
                            const v = optVal(o);
                            return `<div class="option consult-inline-multi-option" data-option="${v}"><span class="option__name">${v}</span><span class="option__checkbox" data-option="${v}"><i class="option__icon-check ri-check-line"></i></span></div>`;
                        }).join('');
                        container.innerHTML = `
                        <label class="consult-inline-label">${label}</label>
                        <div class="list-question consult-inline-multi-select" data-field-id="${fieldId}">${optionsList}</div>
                        <input type="hidden" id="${fieldId}" name="${fieldId}" value="" />
                    `;
                        break;
                    }
                case 'height':
                    container.innerHTML = `
                        <div class="heightQuestion consult-inline-height">
                            <input type="number" min="3" max="8" id="${fieldId}_feet" placeholder="${(0, $knjAn.t)('feet')}" aria-label="${(0, $knjAn.t)('feet')}" />
                            <span>${(0, $knjAn.t)('feet').toUpperCase()}</span>
                            <input type="number" min="0" max="11" id="${fieldId}_inch" placeholder="${(0, $knjAn.t)('inches')}" aria-label="${(0, $knjAn.t)('inches')}" />
                            <span>${(0, $knjAn.t)('inches').toUpperCase()}</span>
                        </div>
                        <input type="hidden" id="${fieldId}" name="${fieldId}" value="" />
                    `;
                    break;
                default:
                    container.innerHTML = `
                        <input id="${fieldId}" name="${fieldId}" type="text" placeholder="${placeholder}" autocomplete="off" aria-label="${label}" />
                    `;
            }
            wrapper.appendChild(container);
        });
        requestForm.insertBefore(wrapper, noteElement);
        $1675b659b2b8ee2b$var$initInlineConsultFields(consultFields.filter((f)=>f.type === 'checkbox' || f.type === 'multi_select' || f.type === 'height' || f.type === 'date'));
    }
    if ((0, $cEKee.locations).length > 1) document.querySelector('.requestConsult__container .location__dropdown').innerHTML = `
        <div data-form="locationConsult" class="locationsDropdown__wrapper dropdown form-control">
            <input id="locationConsult" autocomplete="off" placeholder="${(0, $knjAn.t)('select_location')}">
            <span class="down arrow">
                <i class="ri-arrow-down-s-line"></i>
            </span>
            <span class="up arrow">
                <i class="ri-arrow-up-s-line"></i>
            </span>
            <div class="locationsDropdown__select">
                <ul class="locations__select">
                </ul>
            </div>
        </div>
        `;
    if ((0, $cEKee.providers).length > 1 && !(0, $cEKee.staffId) && !isCategoryEnabled && !hideConsultProviderField) document.querySelector('.requestConsult__container .provider__dropdown').innerHTML = `<div data-form="providerConsult" class="providersDropdown__wrapper dropdown form-control">
                <div style="height: 100%;">
                    <input id="providerConsult" autocomplete="off" placeholder="${(0, $knjAn.t)('select_provider')}">
                    <img class="provider__selected-avt" >
                    <span class="provider__selected-title"></span>
                </div>
                <span class="down-arrow arrow" id="providerConsultDownArrow">
                    <i class="ri-arrow-down-s-line"></i>
                </span>
                <span class="up-arrow arrow" id="providerConsultUpArrow">
                    <i class="ri-arrow-up-s-line"></i>
                </span>
                <div class="providersDropdown__select">
                    <ul class="providers__select"></ul>
                </div>
            </div>`;
    document.querySelector('.requestConsult__container .phone__selected-code img').setAttribute('src', `${(0, $cEKee.appUrl)}/assets/images/svg/${(0, $cEKee.selectedCountry).toLowerCase()}.svg`);
    document.querySelector('.requestConsult__container .selected-country-code').innerHTML = '+' + (0, $cEKee.selectedCodeNumber);
    document.querySelector('.requestConsult__container .phone__countryCode--select').innerHTML = (0, $5Idx5.loadCountriesCodeDropdown)((0, $cIxq8.SCREEN).REQUEST_CONSULT);
}
function $1675b659b2b8ee2b$var$initInlineConsultFields(fieldsWithSpecialHandling) {
    if (!fieldsWithSpecialHandling || fieldsWithSpecialHandling.length === 0) return;
    const container = document.querySelector('.requestConsult__container .custom-consult-fields');
    if (!container) return;
    fieldsWithSpecialHandling.forEach((field)=>{
        const fieldId = `customField__${field.id}`;
        if (field.type === 'checkbox') {
            const hidden = document.getElementById(fieldId);
            const boolGroup = container.querySelector(`.consult-inline-boolean-group`);
            const formControl = container.querySelector(`[data-form="${fieldId}"]`);
            const optionEls = (formControl || boolGroup || container).querySelectorAll('.consult-boolean-option');
            optionEls.forEach((optEl)=>{
                optEl.addEventListener('click', ()=>{
                    optionEls.forEach((o)=>o.classList.remove('is-selected'));
                    optEl.classList.add('is-selected');
                    const radio = optEl.querySelector('input[type="radio"]');
                    if (radio) radio.checked = true;
                    if (hidden) {
                        hidden.value = optEl.dataset.value || '';
                        hidden.dispatchEvent(new Event('change', {
                            bubbles: true
                        }));
                    }
                });
            });
        } else if (field.type === 'multi_select') {
            const listEl = container.querySelector(`.consult-inline-multi-select[data-field-id="${fieldId}"]`);
            const hidden = document.getElementById(fieldId);
            if (!listEl || !hidden) return;
            const options = listEl.querySelectorAll('.consult-inline-multi-option');
            options.forEach((optEl)=>{
                optEl.addEventListener('click', ()=>{
                    const val = optEl.getAttribute('data-option');
                    const checkbox = optEl.querySelector('.option__checkbox');
                    checkbox.classList.toggle('is-selected');
                    const selected = listEl.querySelectorAll('.option__checkbox.is-selected');
                    const arr = Array.from(selected).map((s)=>s.getAttribute('data-option'));
                    hidden.value = JSON.stringify(arr);
                    hidden.dispatchEvent(new Event('change', {
                        bubbles: true
                    }));
                });
            });
        } else if (field.type === 'height') {
            const hidden = document.getElementById(fieldId);
            const feet = document.getElementById(`${fieldId}_feet`);
            const inch = document.getElementById(`${fieldId}_inch`);
            if (hidden && feet && inch) {
                const sync = ()=>{
                    const f = feet.value.trim();
                    const i = inch.value.trim();
                    hidden.value = f || i ? `${f || '0'} FT - ${i || '0'} IN` : '';
                    hidden.dispatchEvent(new Event('change', {
                        bubbles: true
                    }));
                };
                feet.addEventListener('input', sync);
                inch.addEventListener('change', sync);
            }
        } else if (field.type === 'date') {
            const input = document.getElementById(fieldId);
            if (input) requestAnimationFrame(()=>{
                if (window.flatpickr) window.flatpickr(input, {
                    dateFormat: 'Y-m-d',
                    altInput: true,
                    altFormat: 'm/d/Y'
                });
            });
        }
    });
}



var $fQMeL = parcelRequire("fQMeL");
function $60783c4f57b11a7a$export$2d0d80238b015dab() {
// let list = document.querySelector('.surgical__container .surgical__list');
// list.innerHTML = `
//   <div class="surgical" data-surgical-id="1">
//     <span class="surgical__name">Surgical</span>
//     <span class="surgical__checkbox" data-surgical-id="1">
//         <i class="surgical__icon-check ri-check-line"></i>
//     </span>
//   </div>
//   <div class="surgical" data-surgical-id="0">
//     <span class="surgical__name">Non surgical</span>
//     <span class="surgical__checkbox" data-surgical-id="0">
//         <i class="surgical__icon-check ri-check-line"></i>
//     </span>
//   </div>
// `;
}



var $2XKfp = parcelRequire("2XKfp");

var $k3ko8 = parcelRequire("k3ko8");
var $1Yh2H = parcelRequire("1Yh2H");

var $2q2gk = parcelRequire("2q2gk");

var $cIxq8 = parcelRequire("cIxq8");

var $cEKee = parcelRequire("cEKee");

var $eq8l3 = parcelRequire("eq8l3");

var $2XKfp = parcelRequire("2XKfp");

var $er9E0 = parcelRequire("er9E0");

var $gZEOs = parcelRequire("gZEOs");

var $g2qZ3 = parcelRequire("g2qZ3");

var $9bGUq = parcelRequire("9bGUq");

var $1H8Mz = parcelRequire("1H8Mz");

var $f3IK4 = parcelRequire("f3IK4");

var $ifWoM = parcelRequire("ifWoM");
var $56563102da8e9072$var$simpleConsentChecked = false;
function $56563102da8e9072$export$9448dc9a900bb387() {
    /* On focus / blur - use addEventListener so we don't overwrite validation blur handlers */ document.querySelectorAll('div.form-control input').forEach((i)=>{
        i.addEventListener('focus', ()=>{
            const dataForm = i.getAttribute('id');
            document.querySelector(`div[data-form="${CSS.escape(dataForm)}"]`)?.classList.add('on-focus');
        });
        i.addEventListener('blur', ()=>{
            const dataForm = i.getAttribute('id');
            document.querySelector(`div[data-form="${CSS.escape(dataForm)}"]`)?.classList.remove('on-focus');
        });
    });
    /* on change inputs */ const inputs = document.querySelectorAll('.askQuestion__container input');
    inputs.forEach((i)=>{
        i.oninput = ()=>{
            const dataForm = i.getAttribute('id');
            document.querySelector(`.askQuestion__container div[data-form="${CSS.escape(dataForm)}"]`).classList.remove('invalid');
        };
    });
    document.querySelectorAll('.askQuestion__container textarea').forEach((i)=>i.oninput = ()=>{
            const dataForm = i.getAttribute('id');
            document.querySelector(`.askQuestion__container div[data-form="${CSS.escape(dataForm)}"]`).classList.remove('invalid');
        });
    /* on validate name */ $56563102da8e9072$var$validateName();
    /* on format & validate phone number */ $56563102da8e9072$var$formatAndValidatePhone();
    /* toggle country code phone number */ $56563102da8e9072$var$toggleCountryCode();
    /* on change & validate email */ $56563102da8e9072$var$validateEmail();
    /* on check email optin */ $56563102da8e9072$var$onCheckEmailOptin();
    /* Update the consent text with business name */ $56563102da8e9072$var$updateConsentText();
    /* Show/hide consent blocks based on a2p_consent_enabled setting */ const a2pWrapper = document.querySelector('.askQuestion__container .sms-consent__wrapper');
    const simpleWrapper = document.querySelector('.askQuestion__container .sms-consent-simple__wrapper');
    if (0, $cEKee.a2pConsentEnabled) {
        if (a2pWrapper) a2pWrapper.style.display = '';
        if (simpleWrapper) simpleWrapper.style.display = 'none';
        const promotionalRow = document.querySelector('.askQuestion__container .sms-consent-promotional-row');
        if (promotionalRow) promotionalRow.style.display = (0, $cEKee.showSubscribedToOffersOption) ? '' : 'none';
        if (!(0, $cEKee.showSubscribedToOffersOption)) (0, $cEKee.setSmsConsentPromotional)(false);
    } else {
        if (a2pWrapper) a2pWrapper.style.display = 'none';
        if (simpleWrapper) simpleWrapper.style.display = '';
        // Passive consent — no checkbox needed, auto-grant on form display
        $56563102da8e9072$var$simpleConsentChecked = true;
        (0, $cEKee.setSmsConsentTransactional)(true);
        (0, $cEKee.setTermsAndPrivacyAccepted)(true);
    }
    /* on check SMS consent checkboxes (A2P compliance) */ $56563102da8e9072$var$onCheckSmsConsentCheckboxes();
    /* on check Terms and Privacy Policy checkbox */ $56563102da8e9072$var$onCheckTermsPrivacyCheckbox();
    $56563102da8e9072$var$toggleAskAQuestionButtonState();
    /* on click country code Ask a question button */ (0, $ifWoM.countryCodeListeners)();
    /* on click Continue (step 1): validate and go to step 2 or consult summary */ document.querySelectorAll('.askQuestion__container .ask-question-continue__btn').forEach((btn)=>{
        btn.onclick = (e)=>{
            e.preventDefault();
            if (btn.classList.contains('disabled')) return;
            let error = false;
            const step1FormControls = document.querySelectorAll('.askQuestion__container .ask-question-step-1 .form-control');
            for (const i of step1FormControls){
                const dataForm = i.getAttribute('data-form');
                const input = document.querySelector(`.askQuestion__container div[data-form="${CSS.escape(dataForm)}"] #${CSS.escape(dataForm)}`);
                if (!input) continue;
                if (input.getAttribute('id') === 'emailAskQuestion' && !(0, (/*@__PURE__*/$parcel$interopDefault($g2qZ3))).isEmail(input.value) || input.getAttribute('id') === 'phoneAskQuestion' && !(0, $1Yh2H.isValidPhoneNumber)(input.value, (0, $cEKee.selectedCountry)) || input.getAttribute('id') === 'nameAskQuestion' && !(0, $9bGUq.isValidFullName)(input.value) || (0, $cEKee.locations)?.length > 1 && input.getAttribute('id') === 'locationAskAQuestion' && !input.value) {
                    i.classList.add('invalid');
                    error = true;
                }
            }
            if (0, $cEKee.a2pConsentEnabled) // SMS consent checkboxes are optional — only terms & privacy is required
            {
                if (!(0, $cEKee.termsAndPrivacyAccepted)) {
                    const termsPrivacyRow = document.querySelector('.askQuestion__container .terms-privacy-row');
                    if (termsPrivacyRow) termsPrivacyRow.classList.add('invalid');
                    error = true;
                }
            } else if (!$56563102da8e9072$var$simpleConsentChecked) {
                const simpleRow = document.querySelector('.askQuestion__container .sms-consent-simple-row');
                if (simpleRow) simpleRow.classList.add('invalid');
                error = true;
            }
            if (error) return;
            const container = document.querySelector('.askQuestion__container');
            const isBookAppointment = container?.classList.contains('book-appointment');
            if (isBookAppointment) {
                const phone = (0, $k3ko8.parsePhoneNumberFromString)(document.querySelector('#phoneAskQuestion').value, (0, $cEKee.selectedCountry));
                const sourceSelectBooking = document.querySelector('#sourceAskQuestion');
                const selectedSourceBooking = sourceSelectBooking?.value || (0, $cEKee.sourceParam);
                const data = {
                    full_name: document.querySelector('#nameAskQuestion').value,
                    phone: phone.number,
                    email: document.querySelector('#emailAskQuestion').value,
                    email_optin: (0, $cEKee.emailOptin),
                    sms_consent_transactional: (0, $cEKee.smsConsentTransactional),
                    sms_consent_promotional: (0, $cEKee.smsConsentPromotional),
                    terms_and_privacy_accepted: (0, $cEKee.termsAndPrivacyAccepted),
                    ...selectedSourceBooking && {
                        source: selectedSourceBooking
                    },
                    ...(0, $cEKee.visitorId) && {
                        visitor_id: (0, $cEKee.visitorId)
                    },
                    ...(0, $cEKee.selectedLocationId) && {
                        location_id: (0, $cEKee.selectedLocationId)
                    }
                };
                const proTemp = (0, $cEKee.selectedProcedures).map((i)=>(0, $cEKee.procedures).find((j)=>j.id === i));
                (0, $f3IK4.loadConsultDetail)((0, $cEKee.providerServiceSummary), proTemp);
                (0, $cEKee.setLeadInfo)(data);
                document.getElementById('consult-summary')?.focus();
                (0, $er9E0.navigate)((0, $cIxq8.SCREEN).CONSULT_SUMMARY);
                return;
            }
            container?.classList.add('step-2');
            const submitBtn = document.querySelector('.askQuestion__container .ask-question__btn');
            if (submitBtn) {
                submitBtn.classList.remove('disabled');
                submitBtn.removeAttribute('disabled');
            }
        };
    });
    /* on click Ask a question button (step 2): validate question and submit */ document.querySelectorAll('.askQuestion__container .ask-question__btn').forEach((i)=>{
        i.onclick = async (e)=>{
            e.preventDefault();
            const questionInput = document.querySelector('#questionAskQuestion');
            const questionWrap = document.querySelector('.askQuestion__container div[data-form="questionAskQuestion"]');
            if (!questionInput?.value?.trim()) {
                if (questionWrap) questionWrap.classList.add('invalid');
                return;
            }
            if (questionWrap) questionWrap.classList.remove('invalid');
            let error = false;
            const inputs = document.querySelectorAll('.askQuestion__container .form-control');
            for (const fc of inputs){
                const dataForm = fc.getAttribute('data-form');
                const input = document.querySelector(`.askQuestion__container div[data-form="${CSS.escape(dataForm)}"] #${CSS.escape(dataForm)}`);
                if (input?.getAttribute('id') === 'questionAskQuestion' && !document.querySelector('.askQuestion__container.book-appointment') && !input.value?.trim() || input?.getAttribute('id') === 'emailAskQuestion' && !(0, (/*@__PURE__*/$parcel$interopDefault($g2qZ3))).isEmail(input.value) || input?.getAttribute('id') === 'phoneAskQuestion' && !(0, $1Yh2H.isValidPhoneNumber)(input.value, (0, $cEKee.selectedCountry)) || input?.getAttribute('id') === 'nameAskQuestion' && !(0, $9bGUq.isValidFullName)(input.value) || (0, $cEKee.locations)?.length > 1 && input?.getAttribute('id') === 'locationAskAQuestion' && !input.value) {
                    fc.classList.add('invalid');
                    error = true;
                }
            }
            if (error) return;
            if (0, $cEKee.a2pConsentEnabled) // SMS consent checkboxes are optional — only terms & privacy is required
            {
                if (!(0, $cEKee.termsAndPrivacyAccepted)) {
                    const termsPrivacyRow = document.querySelector('.askQuestion__container .terms-privacy-row');
                    if (termsPrivacyRow) termsPrivacyRow.classList.add('invalid');
                    return;
                }
            } else if (!$56563102da8e9072$var$simpleConsentChecked) {
                const simpleRow = document.querySelector('.askQuestion__container .sms-consent-simple-row');
                if (simpleRow) simpleRow.classList.add('invalid');
                return;
            }
            const phone = (0, $k3ko8.parsePhoneNumberFromString)(document.querySelector('#phoneAskQuestion').value, (0, $cEKee.selectedCountry));
            const sourceSelect = document.querySelector('#sourceAskQuestion');
            const selectedSource = sourceSelect?.value || (0, $cEKee.sourceParam);
            const data = {
                full_name: document.querySelector('#nameAskQuestion').value,
                phone: phone.number,
                message: document.querySelector('#questionAskQuestion').value,
                email: document.querySelector('#emailAskQuestion').value,
                email_optin: (0, $cEKee.emailOptin),
                sms_consent_transactional: (0, $cEKee.smsConsentTransactional),
                sms_consent_promotional: (0, $cEKee.smsConsentPromotional),
                terms_and_privacy_accepted: (0, $cEKee.termsAndPrivacyAccepted),
                ...selectedSource && {
                    source: selectedSource
                },
                ...(0, $cEKee.visitorId) && {
                    visitor_id: (0, $cEKee.visitorId)
                },
                ...(0, $cEKee.selectedLocationId) && {
                    location_id: (0, $cEKee.selectedLocationId)
                }
            };
            if (document.querySelector('.askQuestion__container.book-appointment')) {
                const proTemp = (0, $cEKee.selectedProcedures).map((i)=>(0, $cEKee.procedures).find((j)=>j.id === i));
                (0, $f3IK4.loadConsultDetail)((0, $cEKee.providerServiceSummary), proTemp);
                delete data.message;
                (0, $cEKee.setLeadInfo)(data);
                document.getElementById('consult-summary')?.focus();
                (0, $er9E0.navigate)((0, $cIxq8.SCREEN).CONSULT_SUMMARY);
                return;
            }
            (0, $2XKfp.toggleLoading)(true);
            try {
                const lead = await (0, $2q2gk.createLead)(data);
                (0, $cEKee.setLeadTextId)(lead.data.text_id);
                await (0, $2q2gk.updateLeadStep)(lead.data.id, 'question');
                (0, $2XKfp.toggleLoading)(false);
                (0, $1H8Mz.clearInputsAskQs)();
                // A question / Text Us submission is not a booking —
                // thank_you_redirect_url must not fire here.
                (0, $er9E0.setSkipEndRedirect)(true);
                (0, $er9E0.navigate)((0, $cIxq8.SCREEN).THE_END);
            } catch (err) {
                (0, $gZEOs.toastError)(err.response?.data?.message);
                (0, $2XKfp.toggleLoading)(false);
            }
        };
    });
}
function $56563102da8e9072$var$validateName() {
    const name = document.querySelector('#nameAskQuestion');
    const nameWrap = document.querySelector(`.askQuestion__container div[data-form="nameAskQuestion"]`);
    const applyNameValidation = (value)=>{
        if ((0, $9bGUq.isValidFullName)(value)) {
            nameWrap.classList.add('valid');
            nameWrap.classList.remove('invalid');
        } else {
            nameWrap.classList.remove('valid');
            nameWrap.classList.add('invalid');
        }
    };
    name.oninput = (e)=>{
        applyNameValidation(e.target.value);
    };
    name.addEventListener('blur', (e)=>{
        applyNameValidation((e.target.value || '').trim());
    });
}
function $56563102da8e9072$var$formatAndValidatePhone() {
    const phone = document.querySelector('#phoneAskQuestion');
    const phoneWrapper = document.querySelector('.askQuestion__container div[data-form="phoneAskQuestion"]');
    phone.oninput = (e)=>{
        const newValue = (0, $eq8l3.formatPhoneNumber)(e.target.value, (0, $cEKee.selectedCountry));
        phone.value = newValue;
        (0, $eq8l3.validatePhoneNumber)(phoneWrapper, e.target.value);
    };
    phone.addEventListener('blur', ()=>{
        (0, $eq8l3.validatePhoneNumber)(phoneWrapper, phone.value);
    });
}
function $56563102da8e9072$var$toggleCountryCode() {
    document.querySelector(`.phone__selected-code.${(0, $cIxq8.SCREEN).ASK_QUESTION}`).onclick = ()=>(0, $eq8l3.toggleCountriesAskQs)();
}
function $56563102da8e9072$var$validateEmail() {
    const email = document.querySelector('#emailAskQuestion');
    const emailWrap = document.querySelector(`.askQuestion__container div[data-form="emailAskQuestion"]`);
    const applyEmailValidation = (value)=>{
        if ((0, (/*@__PURE__*/$parcel$interopDefault($g2qZ3))).isEmail(value)) {
            emailWrap.classList.add('valid');
            emailWrap.classList.remove('invalid');
        } else {
            emailWrap.classList.remove('valid');
            emailWrap.classList.add('invalid');
        }
    };
    email.oninput = (e)=>{
        applyEmailValidation(e.target.value);
    };
    email.addEventListener('blur', (e)=>{
        applyEmailValidation((e.target.value || '').trim());
    });
}
function $56563102da8e9072$var$onCheckEmailOptin() {
    const checkBox = document.querySelector('.askQuestion__container .emailOptin__checkbox');
    if (!checkBox) return;
    checkBox.onclick = ()=>{
        if (checkBox.classList.contains('is-checked')) {
            checkBox.classList.remove('is-checked');
            (0, $cEKee.setEmailOptin)(false);
        } else {
            checkBox.classList.add('is-checked');
            (0, $cEKee.setEmailOptin)(true);
        }
    };
}
function $56563102da8e9072$var$onCheckSmsConsentCheckboxes() {
    const transactionalCheckbox = document.querySelector('.askQuestion__container .sms-consent-transactional-checkbox');
    const promotionalCheckbox = document.querySelector('.askQuestion__container .sms-consent-promotional-checkbox');
    const transactionalRow = document.querySelector('.askQuestion__container .sms-consent-transactional-row');
    const promotionalRow = document.querySelector('.askQuestion__container .sms-consent-promotional-row');
    const handleTransactionalClick = (e)=>{
        e.preventDefault();
        if (transactionalCheckbox) {
            transactionalCheckbox.classList.toggle('is-checked');
            (0, $cEKee.setSmsConsentTransactional)(transactionalCheckbox.classList.contains('is-checked'));
            transactionalRow?.classList.remove('invalid');
            $56563102da8e9072$var$toggleAskAQuestionButtonState();
        }
    };
    const handlePromotionalClick = (e)=>{
        e.preventDefault();
        if (promotionalCheckbox) {
            promotionalCheckbox.classList.toggle('is-checked');
            (0, $cEKee.setSmsConsentPromotional)(promotionalCheckbox.classList.contains('is-checked'));
            $56563102da8e9072$var$toggleAskAQuestionButtonState();
        }
    };
    if (transactionalRow && transactionalCheckbox) {
        transactionalRow.style.cursor = 'pointer';
        transactionalRow.onclick = handleTransactionalClick;
        transactionalCheckbox.addEventListener('keydown', (e)=>{
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                handleTransactionalClick(e);
            }
        });
    }
    if (promotionalRow && promotionalCheckbox) {
        promotionalRow.style.cursor = 'pointer';
        promotionalRow.onclick = handlePromotionalClick;
        promotionalCheckbox.addEventListener('keydown', (e)=>{
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                handlePromotionalClick(e);
            }
        });
    }
    $56563102da8e9072$var$toggleAskAQuestionButtonState();
}
function $56563102da8e9072$var$onCheckTermsPrivacyCheckbox() {
    const termsPrivacyCheckbox = document.querySelector('.askQuestion__container .terms-privacy-checkbox');
    const termsPrivacyRow = document.querySelector('.askQuestion__container .terms-privacy-row');
    const handleTermsPrivacyClick = (e)=>{
        if (e.target.closest('.terms-link') || e.target.closest('.privacy-link')) return;
        e.preventDefault();
        if (termsPrivacyCheckbox) {
            termsPrivacyCheckbox.classList.toggle('is-checked');
            (0, $cEKee.setTermsAndPrivacyAccepted)(termsPrivacyCheckbox.classList.contains('is-checked'));
            termsPrivacyRow?.classList.remove('invalid');
            $56563102da8e9072$var$toggleAskAQuestionButtonState();
        }
    };
    if (termsPrivacyRow && termsPrivacyCheckbox) {
        termsPrivacyRow.style.cursor = 'pointer';
        termsPrivacyRow.onclick = handleTermsPrivacyClick;
        termsPrivacyCheckbox.addEventListener('keydown', (e)=>{
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                handleTermsPrivacyClick(e);
            }
        });
    }
    $56563102da8e9072$var$toggleAskAQuestionButtonState();
}
function $56563102da8e9072$var$toggleAskAQuestionButtonState() {
    const continueBtn = document.querySelector('.askQuestion__container .ask-question-continue__btn');
    if (continueBtn) {
        var consentMet = false;
        if (0, $cEKee.a2pConsentEnabled) consentMet = (0, $cEKee.termsAndPrivacyAccepted);
        else consentMet = $56563102da8e9072$var$simpleConsentChecked;
        if (consentMet) {
            continueBtn.classList.remove('disabled');
            continueBtn.removeAttribute('disabled');
        } else {
            continueBtn.classList.add('disabled');
            continueBtn.setAttribute('disabled', 'disabled');
        }
    }
}
function $56563102da8e9072$var$updateConsentText() {
    const businessNameSpans = document.querySelectorAll('.askQuestion__container .sms-consent-business-name');
    const practiceNameText = (0, $cEKee.businessName) || '[Business Name]';
    businessNameSpans.forEach((span)=>{
        span.textContent = practiceNameText;
    });
}



var $8ENHq = parcelRequire("8ENHq");

var $cgStI = parcelRequire("cgStI");
function $2222087cd0364acf$export$8e55c0b1f0eddfd7() {
    const procedureContainer = document.querySelector('.procedures__container');
    procedureContainer.onscroll = ()=>{
        const distanceProcedureContainerFromTop = procedureContainer.getBoundingClientRect().top;
        const elements = document.querySelectorAll('.procedure-section__container');
        for (const i of elements){
            const distance = i.getBoundingClientRect().top;
            if (distance < distanceProcedureContainerFromTop + 20 && distance > distanceProcedureContainerFromTop - 20) {
                const allDivCategories = document.querySelectorAll('.category__option');
                const id = i.getAttribute('id');
                for (const j of allDivCategories){
                    j.classList.remove('category__option--selected');
                    if (j.getAttribute('data-id') === id) {
                        j.classList.add('category__option--selected');
                        j.scrollIntoView({
                            behavior: 'smooth',
                            block: 'nearest',
                            inline: 'nearest'
                        });
                    }
                }
            }
        }
    };
}



var $cEKee = parcelRequire("cEKee");

var $er9E0 = parcelRequire("er9E0");
function $048956782fe055b4$export$44f05f845b6676f2() {
    const isWL = (0, $cEKee.form)?.project?.whitelabel ?? false;
    if (isWL) return;
    let url = (0, $er9E0.params)('appUrl');
    let companyUrl = url.includes('kloudmd') ? 'https://kloudmd.com' : 'https://pilotpractice.com';
    document.querySelectorAll('.subFooter--4 span').forEach((i)=>{
        i.onclick = ()=>{
            window.parent.location.href = `${companyUrl}${(0, $cEKee.sourceParam) ? `?source=${0, $cEKee.sourceParam}` : ''}`;
        };
    });
}



var $hGWxM = parcelRequire("hGWxM");

var $cIxq8 = parcelRequire("cIxq8");

var $iUhH6 = parcelRequire("iUhH6");

var $er9E0 = parcelRequire("er9E0");
function $2387e5b671afe639$export$772674902f30d131() {
    /* on select interest*/ document.querySelectorAll('.interests__container .interest').forEach((i)=>{
        i.addEventListener('click', ()=>{
            const value = i.getAttribute('data-interest');
            (0, $iUhH6.selectInterest)(value);
        });
    });
    /* On click enter */ const screenInterests = document.querySelector('.screen--interests');
    if (screenInterests) screenInterests.addEventListener('keydown', (event)=>{
        if (event.key === 'Enter' && !document.querySelector('.interestContinue__btn').classList.contains('disabled')) document.querySelector('.interestContinue__btn').click();
    });
    /* on click Continue after select interest */ document.querySelector('.interestContinue__btn').addEventListener('click', ()=>{
        (0, $er9E0.navigate)((0, $cIxq8.SCREEN).FULL_NAME);
        setTimeout(()=>{
            const fullNameInput = document.getElementById('fullName');
            if (fullNameInput !== document.activeElement) fullNameInput.focus();
        }, 500);
    });
}



var $cIxq8 = parcelRequire("cIxq8");

var $futhG = parcelRequire("futhG");

var $er9E0 = parcelRequire("er9E0");

var $cEKee = parcelRequire("cEKee");
function $66f462f84363ba9e$export$1bf9d194e3b52021() {
    /* on select fullName*/ $66f462f84363ba9e$var$validateName();
    const fullNameElement = document.querySelector('.fullNames__container .fullName');
    if (fullNameElement) fullNameElement.addEventListener('click', (e)=>{
        const fullNameInput = document.getElementById('fullName');
        if (fullNameInput) fullNameInput.focus();
        e.preventDefault();
        let error = false;
        let input = document.querySelector('.fullName--input');
        if (!input.value || input.getAttribute('id') === 'fullName' && !(0, $futhG.isValidFullName)(input.value)) {
            input.classList.add('invalid');
            error = true;
        }
        if (error) return;
    });
    /* On click enter */ const screenFullName = document.querySelector('.screen--fullName');
    if (screenFullName) screenFullName.addEventListener('keydown', (event)=>{
        if (event.key === 'Enter' && !document.querySelector('.fullNameContinue__btn').classList.contains('disabled')) document.querySelector('.fullNameContinue__btn').click();
    });
    /* on click Continue after select fullName */ document.querySelector('.fullNameContinue__btn').addEventListener('click', async ()=>{
        (0, $er9E0.navigate)((0, $cIxq8.SCREEN).EMAIL);
        setTimeout(()=>{
            const emailInput = document.getElementById('email');
            if (emailInput !== document.activeElement) emailInput.focus();
        }, 500);
    });
}
function $66f462f84363ba9e$var$validateName() {
    const name = document.querySelector('#fullName');
    const nameWrap = document.querySelector('.fullName');
    const invalidIcon = document.querySelector('.fullName__invalid');
    const validIcon = document.querySelector('.fullName__valid');
    name.oninput = (e)=>{
        (0, $cEKee.setFullName)(e.target.value);
        if ((0, $futhG.isValidFullName)(e.target.value)) {
            nameWrap.classList.add('valid');
            nameWrap.classList.remove('invalid');
            invalidIcon.classList.add('hidden');
            validIcon.classList.remove('hidden');
            name.classList.remove('invalid');
            document.querySelector('.fullNameContinue__btn').classList.remove('disabled');
        } else {
            nameWrap.classList.remove('valid');
            nameWrap.classList.add('invalid');
            invalidIcon.classList.remove('hidden');
            document.querySelector('.fullNameContinue__btn').classList.add('disabled');
        }
    };
}



var $cIxq8 = parcelRequire("cIxq8");

var $er9E0 = parcelRequire("er9E0");

var $cEKee = parcelRequire("cEKee");

var $g2qZ3 = parcelRequire("g2qZ3");

var $gsdGr = parcelRequire("gsdGr");
function $3b6e9b9ccceceef8$export$2161feb067d9b9c8() {
    $3b6e9b9ccceceef8$var$validateEmail();
    $3b6e9b9ccceceef8$var$onCheckEmail();
    const emailOptInWrapper = document.querySelector('.email__container .emailCheckbox__wrapper');
    if (emailOptInWrapper) {
        emailOptInWrapper.classList.toggle('hide', (0, $cEKee.hideFutureSpecialsOptIn));
        if (0, $cEKee.hideFutureSpecialsOptIn) {
            const checkBox = document.querySelector('.email__container .email__checkbox');
            checkBox?.classList.remove('is-checked');
            (0, $cEKee.setEmailCheck)(false);
        }
    }
    const emailElement = document.querySelector('.email__container .email');
    if (emailElement) emailElement.addEventListener('click', (e)=>{
        const emailInput = document.getElementById('email');
        if (emailInput) emailInput.focus();
        e.preventDefault();
        let error = false;
        let input = document.querySelector('.email--input');
        if (!input.value || input.getAttribute('id') === 'email' && !(0, (/*@__PURE__*/$parcel$interopDefault($g2qZ3))).isEmail(input.value)) {
            input.classList.add('invalid');
            error = true;
        }
        if (error) return;
    });
    /* On click enter */ const screenEmail = document.querySelector('.screen--email');
    if (screenEmail) screenEmail.addEventListener('keydown', (event)=>{
        if (event.key === 'Enter' && !document.querySelector('.emailContinue__btn').classList.contains('disabled')) document.querySelector('.emailContinue__btn').click();
    });
    /* on click Continue after select fullName */ document.querySelector('.emailContinue__btn').addEventListener('click', async ()=>{
        if (0, $cEKee.isInInstantQuote) (0, $gsdGr.oldPhoneUI)();
        else (0, $gsdGr.newPhoneUI)();
        (0, $er9E0.navigate)((0, $cIxq8.SCREEN).PHONE);
        setTimeout(()=>{
            const phoneInput = document.getElementById('phone');
            if (phoneInput !== document.activeElement) phoneInput.focus();
        }, 400);
    });
    /* on click back */ document.querySelector('.emailBack__btn').addEventListener('click', async ()=>{
        setTimeout(()=>{
            const fullNameInput = document.getElementById('fullName');
            if (fullNameInput !== document.activeElement) fullNameInput.focus();
        }, 400);
    });
}
function $3b6e9b9ccceceef8$var$validateEmail() {
    const email = document.querySelector('#email');
    const emailWrap = document.querySelector('.email');
    const invalidIcon = document.querySelector('.email__invalid');
    const validIcon = document.querySelector('.email__valid');
    email.oninput = (e)=>{
        (0, $cEKee.setEmail)(e.target.value);
        if ((0, (/*@__PURE__*/$parcel$interopDefault($g2qZ3))).isEmail(e.target.value)) {
            emailWrap.classList.add('valid');
            emailWrap.classList.remove('invalid');
            invalidIcon.classList.add('hidden');
            email.classList.remove('invalid');
            validIcon.classList.remove('hidden');
            document.querySelector('.emailContinue__btn').classList.remove('disabled');
        } else {
            emailWrap.classList.remove('valid');
            emailWrap.classList.add('invalid');
            invalidIcon.classList.remove('hidden');
            document.querySelector('.emailContinue__btn').classList.add('disabled');
        }
    };
}
function $3b6e9b9ccceceef8$var$onCheckEmail() {
    const checkBox = document.querySelector('.email__container .email__checkbox');
    checkBox.onclick = ()=>{
        if (checkBox.classList.contains('is-checked')) {
            checkBox.classList.remove('is-checked');
            (0, $cEKee.setEmailCheck)(false);
        } else {
            checkBox.classList.add('is-checked');
            (0, $cEKee.setEmailCheck)(true);
        }
    };
}



var $cOK4N = parcelRequire("cOK4N");

var $5rwTR = parcelRequire("5rwTR");

var $1kc6e = parcelRequire("1kc6e");

var $er9E0 = parcelRequire("er9E0");

var $cIxq8 = parcelRequire("cIxq8");

var $cEKee = parcelRequire("cEKee");

var $er9E0 = parcelRequire("er9E0");
function $bf3b5fbb0be7417c$export$862cc17a0e66eeb9() {
    /* Select patient type */ document.querySelectorAll('.consultScheduling__option').forEach((i)=>{
        i.onclick = ()=>{
            document.querySelector('.seeServices__container').classList.add('book-appointment');
            const type = i.getAttribute('data-type');
            let newProcedures = [];
            if (type === (0, $cIxq8.PATIENT_TYPE).EXISTING) newProcedures = (0, $cEKee.procedures).filter((i)=>!i.consult);
            else if (type === (0, $cIxq8.PATIENT_TYPE).NEW_PATIENT) {
                newProcedures = (0, $cEKee.procedures).filter((i)=>i.consult);
                const selectionType = (0, $cEKee.form)?.appointment_channel?.selection_type || (0, $cEKee.form)?.selection_type;
                if (selectionType === (0, $cIxq8.PROCEDURE_SELECTION_TYPE).SINGLE) (0, $cEKee.setProcedureSelectionType)((0, $cIxq8.PROCEDURE_SELECTION_TYPE).SINGLE);
            }
            (0, $cEKee.setProcedures)(newProcedures);
            (0, $er9E0.directToAllServices)('Get Pricing', newProcedures);
        };
    });
}



var $a5XF8 = parcelRequire("a5XF8");

var $iDiGD = parcelRequire("iDiGD");

var $3UENa = parcelRequire("3UENa");

var $gZEOs = parcelRequire("gZEOs");
parcelRequire("2q2gk");

var $cIxq8 = parcelRequire("cIxq8");

var $cEKee = parcelRequire("cEKee");

var $er9E0 = parcelRequire("er9E0");

var $kF2gg = parcelRequire("kF2gg");
function $78cae6baa635da61$export$da7b12389736c7c8() {
    (0, $cEKee.setLeadInfo)({
        text_id: (0, $er9E0.params)((0, $cIxq8.UPLOAD_ID_PARAM))
    });
    (0, $kF2gg.uploadPhotosListeners)();
    let backArrowDom = document.querySelector('.uploadPhotos__container .back-arrow');
    if (backArrowDom) backArrowDom.style.visibility = 'hidden';
    let backButtonDom = document.querySelector('.uploadPhotos__container .uploadPhotos__actions');
    if (backButtonDom) backButtonDom.style.display = 'none';
    document.querySelector((0, $er9E0.getClassScreen)((0, $cIxq8.SCREEN).UPLOAD_PHOTOS)).style.transition = 'none';
    (0, $er9E0.navigate)((0, $cIxq8.SCREEN).UPLOAD_PHOTOS);
}



var $hvLQT = parcelRequire("hvLQT");
async function $29691cac8794886e$export$62969456410a44ae(text_id) {
    return await (0, $hvLQT.apiClient).GET(`api/estimates/${text_id}`);
}


parcelRequire("2q2gk");

var $cIxq8 = parcelRequire("cIxq8");

var $cEKee = parcelRequire("cEKee");

var $gXDoW = parcelRequire("gXDoW");

var $5rwTR = parcelRequire("5rwTR");

var $er9E0 = parcelRequire("er9E0");

var $kF2gg = parcelRequire("kF2gg");

var $9bGUq = parcelRequire("9bGUq");
async function $cf83fa47141f867b$export$ed7964ad3bf65a65() {
    const estimates = await (0, $29691cac8794886e$export$62969456410a44ae)((0, $er9E0.params)((0, $cIxq8.ESTIMATE_ID_PARAM)));
    if (estimates) {
        (0, $cEKee.setEstimateInfo)(estimates.data);
        (0, $gXDoW.loadSelectedProcedures)();
        (0, $5rwTR.instantQuoteSummaryListeners)();
        (0, $5rwTR.handleInstantQuoteSummary)();
        (0, $cEKee.setLeadTextId)(estimates.data.lead.text_id);
        (0, $cEKee.setLeadInfo)(estimates.data.lead);
        (0, $cEKee.setProviderId)(estimates.data.staff_id);
        let refreshBtnDom = document.querySelector('.instant_quote_summary__container .refresh.instant_quote--again');
        let phoneBtnDom = document.querySelector('.instant_quote_summary__container .phone.instant_quote--again');
        if (refreshBtnDom) refreshBtnDom.style.visibility = 'hidden';
        if (phoneBtnDom) phoneBtnDom.style.visibility = 'hidden';
        document.querySelector((0, $er9E0.getClassScreen)((0, $cIxq8.SCREEN).INSTANT_QUOTE_SUMMARY)).style.transition = 'none';
        (0, $er9E0.navigate)((0, $cIxq8.SCREEN).INSTANT_QUOTE_SUMMARY);
        /* On click Still interested, request a consultation  */ document.querySelector('.consultSummary__container .consult-summary__btn').onclick = (e)=>{
            e.preventDefault();
            if ((0, $cEKee.form).form?.custom_fields.length > 0) {
                let item = (0, $cEKee.form).form.custom_fields[0];
                (0, $cEKee.setCustomFields)((0, $cEKee.form).form.custom_fields.filter((custom_field)=>custom_field.id !== item.id));
                (0, $cEKee.setCustomField)(item);
                (0, $cEKee.setProgressQuestion)({
                    currentQuestion: 1,
                    total: (0, $cEKee.form).form.custom_fields.length,
                    progress: 1 / (0, $cEKee.form).form.custom_fields.length * 100
                });
                (0, $9bGUq.loadCustomFields)((0, $cEKee.customField));
            } else if (0, $cEKee.fileUploadChannel) {
                (0, $kF2gg.uploadPhotosListeners)();
                (0, $er9E0.navigate)((0, $cIxq8.SCREEN).UPLOAD_PHOTOS);
            } else (0, $er9E0.navigate)((0, $cIxq8.SCREEN).THE_END);
        };
    }
}



var $8Jd2Q = parcelRequire("8Jd2Q");

var $cIxq8 = parcelRequire("cIxq8");

var $cEKee = parcelRequire("cEKee");

var $er9E0 = parcelRequire("er9E0");
function $6929ae063ef9e5f0$export$a8565b6bdf6e359c() {
    const bookAppointmentContainer = document.querySelector('.bookAnAppointment__container');
    if (bookAppointmentContainer) {
        let cssProperties = {
            zIndex: (0, $cEKee.isModalPopup) ? 0 : 3,
            right: 0
        };
        Object.assign(bookAppointmentContainer.style, cssProperties);
    }
    if (0, $cEKee.isModalPopup) {
        let assistant = document?.querySelector('.assistant__iframe');
        if (assistant) assistant.style.opacity = 0;
    }
    const continueBtn = bookAppointmentContainer.querySelector('.bookAppointmentContinue__btn');
    if (continueBtn) continueBtn.addEventListener('click', $6929ae063ef9e5f0$var$handleClickContinueBtn);
    $6929ae063ef9e5f0$var$listenModalAppointmentFistPage();
}
function $6929ae063ef9e5f0$var$handleClickContinueBtn() {
    const bookAppointmentContainer = document.querySelector('.bookAnAppointment__container');
    if (!bookAppointmentContainer) return;
    let cssProperties = {
        zIndex: 0
    };
    Object.assign(bookAppointmentContainer.style, cssProperties);
    (0, $er9E0.openBookAppointment)();
}
function $6929ae063ef9e5f0$var$listenModalAppointmentFistPage() {
    const bookAppointmentContainer = document.querySelector('.bookAppointmentFistScreen__container');
    const continueBtn = bookAppointmentContainer.querySelector('.bookAppointmentContinue__btn');
    if (continueBtn) continueBtn.addEventListener('click', $6929ae063ef9e5f0$var$handleClickContinueBtnModal);
}
function $6929ae063ef9e5f0$var$handleClickContinueBtnModal() {
    let assistant = document?.querySelector('.assistant__iframe');
    if (assistant) assistant.style.opacity = 1;
    parent.postMessage((0, $cIxq8.OPEN_BOOK_APPOINTMENT_MODAL), '*');
}



var $8QS3m = parcelRequire("8QS3m");

var $d0tLC = parcelRequire("d0tLC");

var $hprW2 = parcelRequire("hprW2");

var $62LVp = parcelRequire("62LVp");

var $cFczh = parcelRequire("cFczh");
let $df8dbfc52b347d84$var$buttonTriggered = '';
window.onload = async ()=>{
    window.addEventListener('keydown', (e)=>{
        if (e.key === 'Tab') e.preventDefault();
        if (e.key === 'Escape' && (0, $er9E0.params)('modal-popup')) /* Send `message` to the parent */ parent.postMessage('close_modal_popup', "*");
    });
    (0, $cEKee.setAppUrl)((0, $er9E0.params)('appUrl'));
    (0, $cEKee.setPrimaryColor)('#' + (0, $er9E0.params)('color'));
    (0, $cEKee.setStaffId)((0, $er9E0.params)('staff_id') ?? 0);
    (0, $cEKee.setProcedureIdSelected)((0, $er9E0.params)('procedure_id') ?? 0);
    /* Set primary color */ document.body.style.setProperty('--primary-color', (0, $cEKee.primaryColor));
    const formIdParam = (0, $er9E0.params)('form_id') || (0, $er9E0.params)('form');
    if (formIdParam) (0, $cEKee.setFormId)(formIdParam);
    const form = await (0, $1f5FT.getFormByFormId)(formIdParam, (0, $er9E0.params)('appointment_channel_id'), (0, $er9E0.params)('path') || null);
    // Whitelabel branding: hide PilotPractice references when project has whitelabel enabled
    const projectWhitelabel = form?.data?.project?.whitelabel ?? false;
    if (projectWhitelabel) {
        // Hide "Powered by PilotPractice"
        document.querySelectorAll('.subFooter--4').forEach((el)=>{
            el.innerHTML = '';
        });
        // Terms/Privacy links: point to project website instead of pilotpractice.com
        const projectWebsite = form?.data?.project?.website;
        document.querySelectorAll('.note .link').forEach((i)=>{
            if (projectWebsite) i.onclick = (e)=>{
                e.stopPropagation();
                window.parent.parent.location.href = projectWebsite;
            };
            else {
                i.style.cursor = 'default';
                i.style.textDecoration = 'none';
            }
        });
    } else {
        document.querySelectorAll('.note .link').forEach((i)=>{
            i.onclick = (e)=>{
                e.stopPropagation();
                window.parent.parent.location.href = i.textContent === 'Terms' ? 'https://pilotpractice.com/terms-and-conditions/' : 'https://pilotpractice.com/privacy-policy/';
            };
        });
        var elements = document.querySelectorAll('.powered_by');
        for(var i = 0; i < elements.length; i++){
            elements[i].innerHTML = ((0, $er9E0.params)('appUrl') || '').includes('kloudmd') ? 'KloudMD' : 'PilotPractice';
            const parentSpan = elements[i].closest('span');
            if (parentSpan && parentSpan.firstChild?.nodeType === Node.TEXT_NODE) parentSpan.firstChild.textContent = (0, $knjAn.t)('powered_by') + ' ';
        }
    }
    // Contact prefill handed off via URL params (e.g. kloudmd.com/get-started):
    // seed the static request-consult inputs. Assigned via .value, so inert as HTML.
    const nameConsultEl = document.querySelector('#nameConsult');
    if (nameConsultEl && !nameConsultEl.value && (0, $cFczh.urlPrefill).full_name) nameConsultEl.value = (0, $cFczh.urlPrefill).full_name;
    const emailConsultEl = document.querySelector('#emailConsult');
    if (emailConsultEl && !emailConsultEl.value && (0, $cFczh.urlPrefill).email) emailConsultEl.value = (0, $cFczh.urlPrefill).email;
    (0, $cEKee.setHiddenPages)(form?.data?.hidden_pages ?? []);
    if (!form.data?.hidden_pages?.includes('patient_page')) {
        if (!form.data?.appointment_channel?.patient_type_selection) (0, $cEKee.setHiddenPages)([
            ...(0, $cEKee.hiddenPages),
            'patient_page'
        ]);
    }
    if (!form.data?.hidden_pages?.includes('surgical')) (0, $cEKee.setHiddenPages)([
        ...(0, $cEKee.hiddenPages),
        'surgical'
    ]);
    if ((0, $er9E0.params)('appointment_channel_id')) {
        (0, $cEKee.setAppointmentChannelId)((0, $er9E0.params)('appointment_channel_id'));
        const staffsOfAppointmentChannel = form?.appointment_channel?.staffs?.filter((staff)=>staff?.online_booking);
        const hostType = form?.appointment_channel?.host || (0, $cIxq8.HOST_TYPE_ONE_ON_ONE);
        if (hostType === (0, $cIxq8.HOST_TYPE_ROUND_ROBIN) && staffsOfAppointmentChannel?.length > 0) {
            const selectedStaff = staffsOfAppointmentChannel[0];
            (0, $cEKee.setStaffId)(selectedStaff?.id);
        } else if (hostType === (0, $cIxq8.HOST_TYPE_COLLECTIVE) && staffsOfAppointmentChannel?.length > 0) {
            const selectedStaff = staffsOfAppointmentChannel[0];
            (0, $cEKee.setStaffId)(selectedStaff?.id);
        } else if (staffsOfAppointmentChannel?.length === 1) {
            const staff = staffsOfAppointmentChannel[0];
            if (staff) (0, $cEKee.setStaffId)(staff?.id);
        }
        const procedure = form.data?.appointment_channel?.procedures && form.data?.appointment_channel?.procedures[0];
        if (procedure && form.data?.appointment_channel?.procedures?.length === 1) {
            (0, $cEKee.setProcedureIdSelected)(procedure?.id);
            (0, $cEKee.setSelectedProcedures)([
                procedure?.id
            ]);
        }
    } else if (form.data?.appointment_request_type === (0, $cIxq8.APPOINTMENT_REQUEST_CALENDAR)) {
        (0, $cEKee.setAppointmentChannelId)(form.data?.appointment_channel?.id);
        (0, $cEKee.setShouldCollectPatientInfoFirstForWidget)(true);
        (0, $cEKee.setIsFlowForCalendar)(true);
        const staffsOfAppointmentChannel = form?.appointment_channel?.staffs?.filter((staff)=>staff?.online_booking);
        const hostType = form.data?.appointment_channel?.host_type || (0, $cIxq8.HOST_TYPE_ONE_ON_ONE);
        if (hostType === (0, $cIxq8.HOST_TYPE_ROUND_ROBIN) && staffsOfAppointmentChannel?.length > 0) {
            const selectedStaff = staffsOfAppointmentChannel[0];
            (0, $cEKee.setStaffId)(selectedStaff?.id);
        } else if (hostType === (0, $cIxq8.HOST_TYPE_COLLECTIVE) && staffsOfAppointmentChannel?.length > 0) {
            const selectedStaff = staffsOfAppointmentChannel[0];
            (0, $cEKee.setStaffId)(selectedStaff?.id);
        } else if (staffsOfAppointmentChannel?.length === 1) {
            const staff = staffsOfAppointmentChannel && staffsOfAppointmentChannel[0];
            if (staff) (0, $cEKee.setStaffId)(staff?.id);
        }
        const procedure = form.data?.appointment_channel?.procedures && form.data?.appointment_channel?.procedures[0];
        if (procedure && form.data?.appointment_channel?.procedures?.length === 1) {
            (0, $cEKee.setProcedureIdSelected)(procedure?.id);
            (0, $cEKee.setSelectedProcedures)([
                procedure?.id
            ]);
        }
    }
    if (form?.data?.default_language) {
        (0, $cEKee.setSelectedLanguage)(form.data.default_language);
        moment.locale(form.data.default_language);
        const titleEl = document.getElementById('main-menu-title');
        if (titleEl) titleEl.textContent = (0, $knjAn.t)('instant_actions');
        const staticTitles = [
            {
                sel: '.locations__container .title__content',
                key: 'get_instant_estimate'
            },
            {
                sel: '.location--title',
                key: 'select_location'
            },
            {
                sel: '.seeServices__container .title__content',
                key: 'select_services'
            },
            {
                sel: '.interests__container .title__content',
                key: 'get_instant_estimate'
            },
            {
                sel: '.fullNames__container .title__content',
                key: 'get_instant_estimate'
            },
            {
                sel: '.email__container .title__content',
                key: 'get_instant_estimate'
            },
            {
                sel: '.selectOnlyDate__container .selectOnlyTime__title-text',
                key: 'select_date_time'
            },
            {
                sel: '.selectOnlyTime__container .selectOnlyTime__title-sub',
                key: 'available_time'
            }
        ];
        staticTitles.forEach(({ sel: sel, key: key })=>{
            const el = document.querySelector(sel);
            if (el) el.textContent = (0, $knjAn.t)(key);
        });
        const selectOnlyTimeSpan = document.querySelector('.selectOnlyTime__container .selectOnlyTime__title-text > span:not(.back-arrow)');
        if (selectOnlyTimeSpan) selectOnlyTimeSpan.textContent = (0, $knjAn.t)('select_date_time');
        // Re-apply "Powered by" translation (language is now set; the first pass runs before setSelectedLanguage)
        document.querySelectorAll('.powered_by').forEach((el)=>{
            const parentSpan = el.closest('span');
            if (parentSpan && parentSpan.firstChild?.nodeType === Node.TEXT_NODE) parentSpan.firstChild.textContent = (0, $knjAn.t)('powered_by') + ' ';
        });
        // Update "Continue" button text nodes in HTML
        [
            '.locationContinue__btn',
            '.procedureContinue__btn',
            '.interestContinue__btn',
            '.fullNameContinue__btn',
            '.emailContinue__btn',
            '.validateDigitsContinue__btn',
            '.register-new-patient-continue__btn',
            '.genderContinue__btn',
            '.bodySelectionContinue__btn',
            '.bookAppointmentContinue__btn',
            '.patientContinue__btn'
        ].forEach((sel)=>{
            document.querySelectorAll(sel).forEach((btn)=>{
                const textNode = Array.from(btn.childNodes).find((n)=>n.nodeType === Node.TEXT_NODE && n.textContent.trim());
                if (textNode) textNode.textContent = (0, $knjAn.t)('continue') + ' ';
            });
        });
        [
            '.address-collection__btn',
            '.ask-question-continue__btn'
        ].forEach((sel)=>{
            const btn = document.querySelector(sel);
            if (btn) btn.textContent = (0, $knjAn.t)('continue');
        });
        const allQContinue = document.querySelector('.allQuestionsContinue__btn .text');
        if (allQContinue) allQContinue.textContent = (0, $knjAn.t)('continue');
        // Screen titles
        [
            [
                '.topQuestion__container .title__content',
                'top_asked_questions'
            ],
            [
                '.requestConsult__container .title__content',
                'request_consult_title'
            ],
            [
                '.providers__container .title__content',
                'get_an_instant_estimate'
            ],
            [
                '.consultScheduling__container .title__content',
                'consult_scheduling'
            ],
            [
                '.consultScheduling__title',
                'hello_there'
            ],
            [
                '.interest--title',
                'when_done'
            ],
            [
                '.phone__container .title__content',
                'enter_phone_number'
            ],
            [
                '.validateDigits__container .title__content',
                'enter_otp_code'
            ],
            [
                '.register-new-patient__container .title__content',
                'register_as_new_patient'
            ],
            [
                '.register-new-patient__header .title',
                'tell_us_about_yourself'
            ],
            [
                '.register-new-patient__header .subtitle',
                'client_portal_info'
            ],
            [
                '.instant_quote_summary__container .title__content',
                'your_instant_quote'
            ],
            [
                '.surgical__container .title__content',
                'book_your_appointment'
            ],
            [
                '.address-collection__container .title__content',
                'your_address'
            ],
            [
                '.appointment-summary__container .title__content',
                'appointment_summary_title'
            ],
            [
                '.card-collection__container .title__content',
                'please_confirm_appointment'
            ],
            [
                '.widgetScreen__container.instant-quote .title__content',
                'instant_quote_title'
            ],
            [
                '.providerScheduling__container .title__content',
                'consult_scheduling'
            ],
            [
                '.serviceSummary__container .title__content',
                'book_your_appointment'
            ],
            [
                '.askQuestion__container .title__content',
                'we_will_reach_back'
            ],
            [
                '.categories__container .title__content',
                'select_category'
            ]
        ].forEach(([sel, key])=>{
            const el = document.querySelector(sel);
            if (el) el.textContent = (0, $knjAn.t)(key);
        });
        // Placeholders (by ID)
        [
            [
                'nameConsult',
                'first_last_name_placeholder'
            ],
            [
                'procedureConsult',
                'type_desired_service'
            ],
            [
                'emailConsult',
                'email_short'
            ],
            [
                'phoneConsult',
                'mobile_phone_placeholder'
            ],
            [
                'fullName',
                'full_name_short_placeholder'
            ],
            [
                'email',
                'email_short'
            ],
            [
                'nameAskQuestion',
                'first_last_name_placeholder'
            ],
            [
                'emailAskQuestion',
                'email_short'
            ],
            [
                'phoneAskQuestion',
                'mobile_phone_placeholder'
            ],
            [
                'questionAskQuestion',
                'whats_your_question'
            ],
            [
                'addressLine1',
                'address_main_placeholder'
            ],
            [
                'addressLine2',
                'apt_suite_placeholder'
            ],
            [
                'addressCity',
                'city_short'
            ],
            [
                'addressState',
                'state_short'
            ],
            [
                'addressZip',
                'zip_short'
            ],
            [
                'dobDatepicker',
                'select_dob'
            ]
        ].forEach(([id, key])=>{
            const el = document.getElementById(id);
            if (el) el.placeholder = (0, $knjAn.t)(key);
        });
        // Register new patient placeholders (no IDs)
        const rnpInputs = document.querySelectorAll('.register-new-patient__input input:not(#dobDatepicker)');
        if (rnpInputs[0]) rnpInputs[0].placeholder = (0, $knjAn.t)('enter_first_name');
        if (rnpInputs[1]) rnpInputs[1].placeholder = (0, $knjAn.t)('enter_last_name');
        // Register new patient labels
        const rnpLabels = document.querySelectorAll('.register-new-patient__input label');
        if (rnpLabels[0]) rnpLabels[0].textContent = (0, $knjAn.t)('first_name');
        if (rnpLabels[1]) rnpLabels[1].textContent = (0, $knjAn.t)('last_name');
        if (rnpLabels[2]) rnpLabels[2].textContent = (0, $knjAn.t)('dob');
        // Address labels
        [
            [
                'addressLine1',
                'street_address_label'
            ],
            [
                'addressLine2',
                'apt_suite_optional_label'
            ],
            [
                'addressCity',
                'city_short'
            ],
            [
                'addressState',
                'state_short'
            ],
            [
                'addressZip',
                'zip_code'
            ]
        ].forEach(([forAttr, key])=>{
            const el = document.querySelector(`label[for="${forAttr}"]`);
            if (el) el.textContent = (0, $knjAn.t)(key);
        });
        // Field labels (class-based)
        [
            [
                '.fullNames--title',
                'your_full_name_label'
            ],
            [
                '.fullName__label',
                'your_first_last_name_label'
            ],
            [
                '.email--title',
                'your_email_address_label'
            ],
            [
                '.email__label',
                'email_address_label'
            ]
        ].forEach(([sel, key])=>{
            const el = document.querySelector(sel);
            if (el) el.textContent = (0, $knjAn.t)(key);
        });
        // Consult scheduling screen
        [
            [
                '.consultScheduling__subTitle',
                'ready_to_schedule'
            ],
            [
                '.consultScheduling__option[data-type="new-user"]',
                'i_am_new_user'
            ],
            [
                '.consultScheduling__option[data-type="existing-user"]',
                'i_am_existing_user'
            ]
        ].forEach(([sel, key])=>{
            const el = document.querySelector(sel);
            if (el) el.textContent = (0, $knjAn.t)(key);
        });
        // Phone screen submit button
        const phoneSubmitSpan = document.querySelector('.phoneContinue__btn span:not(.loader__icon)');
        if (phoneSubmitSpan) phoneSubmitSpan.textContent = (0, $knjAn.t)('submit');
        // OTP / validate digits screen (static HTML)
        const validateTitle = document.querySelector('.validateDigits--title');
        if (validateTitle) validateTitle.textContent = (0, $knjAn.t)('enter_4_digit_code');
        const sentToDiv = document.querySelector('.validateDigits--sub-title');
        if (sentToDiv) {
            const textNode = Array.from(sentToDiv.childNodes).find((n)=>n.nodeType === Node.TEXT_NODE && n.textContent.trim());
            if (textNode) textNode.textContent = (0, $knjAn.t)('sent_to') + ' ';
        }
        const editPhoneBtn = document.querySelector('.edit-phone-btn');
        if (editPhoneBtn) editPhoneBtn.textContent = (0, $knjAn.t)('edit_btn');
        const resendU = document.querySelector('.validateDigits--resend-otp u');
        if (resendU) resendU.textContent = (0, $knjAn.t)('resend');
        // Instant quote screen
        const quoteTotalTitle = document.querySelector('.js-quote-total-title');
        if (quoteTotalTitle) quoteTotalTitle.textContent = (0, $knjAn.t)('total');
        const financingText = document.querySelector('.js-financing--text');
        if (financingText) financingText.textContent = (0, $knjAn.t)('as_low_as');
        const quoteTotalTitle2 = document.querySelector('.js-quote-total-title-2');
        if (quoteTotalTitle2) quoteTotalTitle2.textContent = (0, $knjAn.t)('total_lowercase');
        const costBreakdown = document.querySelector('.step__breakdown > span');
        if (costBreakdown) costBreakdown.textContent = (0, $knjAn.t)('cost_breakdown');
        const noEstimates = document.querySelector('.noEstimates');
        if (noEstimates) noEstimates.textContent = (0, $knjAn.t)('no_estimate_info');
        const estimateNote = document.querySelector('.summary__actions .note');
        if (estimateNote) estimateNote.textContent = (0, $knjAn.t)('estimate_disclaimer');
        const summaryContinueBtn = document.querySelector('.summaryContinue__btn');
        if (summaryContinueBtn) {
            const textNode = Array.from(summaryContinueBtn.childNodes).find((n)=>n.nodeType === Node.TEXT_NODE && n.textContent.trim());
            if (textNode) textNode.textContent = (0, $knjAn.t)('request_consultation') + ' ';
        }
        // Request consult button text
        const requestConsultBtnText = document.querySelector('.requestConsult__btn .text');
        if (requestConsultBtnText) requestConsultBtnText.textContent = (0, $knjAn.t)('request_consultation');
        // Surgical types
        const surgicalSpan = document.querySelector('#button--surgical .title-wrapper__title span');
        if (surgicalSpan) surgicalSpan.textContent = (0, $knjAn.t)('surgical');
        const nonSurgicalSpan = document.querySelector('#button--non-surgical .title-wrapper__title span');
        if (nonSurgicalSpan) nonSurgicalSpan.textContent = (0, $knjAn.t)('non_surgical');
        // Address screen
        const addressSubtitle = document.querySelector('.address-collection__subtitle');
        if (addressSubtitle) addressSubtitle.textContent = (0, $knjAn.t)('address_subtitle');
        // Appointment summary screen
        const confirmTitle = document.querySelector('.confirmation-title');
        if (confirmTitle) confirmTitle.textContent = (0, $knjAn.t)('please_confirm_appointment');
        const minuteConsultMsg = document.querySelector('.appointment__banner .message');
        if (minuteConsultMsg) {
            const textNode = Array.from(minuteConsultMsg.childNodes).find((n)=>n.nodeType === Node.TEXT_NODE && n.textContent.trim());
            if (textNode) textNode.textContent = ' ' + (0, $knjAn.t)('minute_consult_required');
        }
        const appointmentDetailsTitle = document.querySelector('.appoitment-details__title');
        if (appointmentDetailsTitle) appointmentDetailsTitle.textContent = (0, $knjAn.t)('services');
        const appointmentSummaryConfirmText = document.querySelector('.appointment-summary__continue-btn .text');
        if (appointmentSummaryConfirmText) appointmentSummaryConfirmText.textContent = (0, $knjAn.t)('confirm');
        // Card collection screen
        const saveCardText = document.querySelector('.card-collection__continue-btn .text');
        if (saveCardText) saveCardText.textContent = (0, $knjAn.t)('save_card_and_confirm');
        // Sign in links
        document.querySelectorAll('#header-sign-in-client-portal, #header-sign-in-client-portal-reschedule').forEach((el)=>{
            el.textContent = (0, $knjAn.t)('sign_in');
        });
        // Appointment confirmed - appointment date
        const appointmentDateTitle = document.querySelector('.appointment-confirmed__datetime-section .title-text');
        if (appointmentDateTitle) appointmentDateTitle.textContent = (0, $knjAn.t)('appointment_date');
        // Appointment cancel screen
        const cancelContainerTitle = document.querySelector('.appointment-cancel__container .title__content');
        if (cancelContainerTitle) cancelContainerTitle.textContent = (0, $knjAn.t)('appointment_summary_title');
        const cancelledTitle = document.querySelector('.appointment-cancel__container .title.w-100');
        if (cancelledTitle) cancelledTitle.textContent = (0, $knjAn.t)('appointment_cancelled_title');
        // Appointment reschedule screens
        [
            [
                '.appointment-reschedule__container .title__content',
                'reschedule_appointment'
            ],
            [
                '.appointment-reschedule__container .title.w-100',
                'reschedule_your_appointment'
            ],
            [
                '.appointment-reschedule-reason__datetime-section .title.w-100',
                'appointment_date'
            ]
        ].forEach(([sel, key])=>{
            const el = document.querySelector(sel);
            if (el) el.textContent = (0, $knjAn.t)(key);
        });
        const currentLabel = document.querySelector('.current-appointment .reschedule-row-label');
        if (currentLabel) currentLabel.textContent = (0, $knjAn.t)('current_label');
        const newTimeLabel = document.querySelector('.new-appointment .reschedule-row-label');
        if (newTimeLabel) newTimeLabel.textContent = (0, $knjAn.t)('new_time_label');
        // Provider scheduling - available date
        const availableDateSpan = document.querySelector('.providerScheduling__date > span');
        if (availableDateSpan) availableDateSpan.textContent = (0, $knjAn.t)('available_date');
        // Service summary - book now
        const bookNowBtn = document.querySelector('.serviceSummary__bookNow');
        if (bookNowBtn) bookNowBtn.textContent = (0, $knjAn.t)('book_now');
        // Consult summary screen
        [
            [
                '.consultSummary__container .title__content',
                'consult_summary'
            ],
            [
                '.consult-summary__btn',
                'still_interested_consult'
            ]
        ].forEach(([sel, key])=>{
            const el = document.querySelector(sel);
            if (el) el.textContent = (0, $knjAn.t)(key);
        });
        // Upload photos screen
        [
            [
                '.uploadPhotos__container .title__content',
                'upload_your_photos'
            ],
            [
                '.uploadPhotosTop__heading-title',
                'upload_your_photos'
            ],
            [
                '.uploadPhotosTop__heading-desc',
                'upload_photos_desc'
            ],
            [
                '.uploadPhotosDesc__title',
                'upload_click_or_drag'
            ],
            [
                '.uploadPhotosDesc__text',
                'upload_multiple_files'
            ]
        ].forEach(([sel, key])=>{
            const el = document.querySelector(sel);
            if (el) el.textContent = (0, $knjAn.t)(key);
        });
        const skipStepBtn = document.querySelector('.uploadPhotosContinue__btn');
        if (skipStepBtn) {
            const textNode = Array.from(skipStepBtn.childNodes).find((n)=>n.nodeType === Node.TEXT_NODE && n.textContent.trim());
            if (textNode) textNode.textContent = (0, $knjAn.t)('skip_step') + ' ';
        }
        // Gender screen
        const genderScreenTitle = document.querySelector('.gender__container .title__content');
        if (genderScreenTitle) genderScreenTitle.textContent = (0, $knjAn.t)('select_your_gender');
        document.querySelectorAll('.select__gender').forEach((btn, i)=>{
            btn.textContent = i === 0 ? (0, $knjAn.t)('male') : (0, $knjAn.t)('female');
        });
        // Body area selection screen
        const bodyAreaTitle = document.querySelector('.bodyAreaSelection__container .title__content');
        if (bodyAreaTitle) bodyAreaTitle.textContent = (0, $knjAn.t)('select_problem_areas');
        // Book appointment screens (two instances)
        document.querySelectorAll('.bookAppointment__title').forEach((el)=>{
            el.textContent = (0, $knjAn.t)('book_an_appointment');
        });
        document.querySelectorAll('.bookAppointment__desc').forEach((el)=>{
            el.textContent = (0, $knjAn.t)('click_continue_to_book');
        });
        // All questions screen
        const questionsTitle = document.querySelector('.allQuestions__container .title__content');
        if (questionsTitle) questionsTitle.textContent = (0, $knjAn.t)('questions_title');
        // Verify information screen
        [
            [
                '.verifyInformation__container .title__content',
                'verify_information_title'
            ],
            [
                '.verify-infor__header .title',
                'verify_information_subtitle'
            ],
            [
                '.verify-infor__header .subtitle',
                'verify_information_desc'
            ],
            [
                '.verify-infor-continue__btn .text',
                'verify_btn'
            ]
        ].forEach(([sel, key])=>{
            const el = document.querySelector(sel);
            if (el) el.textContent = (0, $knjAn.t)(key);
        });
        // Patients screen
        const patientsScreenTitle = document.querySelector('.patients__container .title__content');
        if (patientsScreenTitle) patientsScreenTitle.textContent = (0, $knjAn.t)('book_an_appointment');
        const patientScreenSubtitle = document.querySelector('.patient--title');
        if (patientScreenSubtitle) patientScreenSubtitle.textContent = (0, $knjAn.t)('are_you_new_patient');
        // Call us screen
        const callUsTitle = document.querySelector('.callus_container .title__content');
        if (callUsTitle) callUsTitle.textContent = (0, $knjAn.t)('call_us');
        const callUsSubtitle = document.querySelector('.callus--title');
        if (callUsSubtitle) callUsSubtitle.textContent = (0, $knjAn.t)('select_location_to_call');
        // Ask a question screen
        const askQuestionBtn = document.querySelector('.ask-question__btn');
        if (askQuestionBtn) askQuestionBtn.textContent = (0, $knjAn.t)('ask_a_question');
        // End screen
        const mainText = document.querySelector('.main-text');
        if (mainText) mainText.textContent = (0, $knjAn.t)('thanks');
        const notifyText = document.querySelector('.notify-text');
        if (notifyText) notifyText.textContent = (0, $knjAn.t)('message_received');
        // Email checkbox label
        const notifySpecialsSpan = document.querySelector('.emailCheckbox__wrapper > span');
        if (notifySpecialsSpan) notifySpecialsSpan.textContent = (0, $knjAn.t)('notify_future_specials');
        // SMS consent aria-labels (both requestConsult and askQuestion sections)
        document.querySelectorAll('.sms-consent-transactional-checkbox').forEach((el)=>el.setAttribute('aria-label', (0, $knjAn.t)('sms_transactional_aria')));
        document.querySelectorAll('.terms-privacy-checkbox').forEach((el)=>el.setAttribute('aria-label', (0, $knjAn.t)('terms_privacy_aria')));
        document.querySelectorAll('.sms-consent-promotional-checkbox').forEach((el)=>el.setAttribute('aria-label', (0, $knjAn.t)('sms_promotional_aria')));
        document.querySelectorAll('.sms-consent-disclaimer').forEach((el)=>{
            el.textContent = (0, $knjAn.t)('sms_disclaimer');
        });
        // SMS transactional label: "I agree to receive... from [Business Name] (e.g. ...)"
        document.querySelectorAll('.sms-consent-transactional-row .sms-consent-label').forEach((el)=>{
            const nodes = Array.from(el.childNodes).filter((n)=>n.nodeType === Node.TEXT_NODE);
            if (nodes[0]) nodes[0].textContent = (0, $knjAn.t)('sms_transactional_before');
            if (nodes[1]) nodes[1].textContent = (0, $knjAn.t)('sms_transactional_after');
        });
        // SMS promotional label: "I agree to receive... from [Business Name]."
        document.querySelectorAll('.sms-consent-promotional-row .sms-consent-label').forEach((el)=>{
            const nodes = Array.from(el.childNodes).filter((n)=>n.nodeType === Node.TEXT_NODE);
            if (nodes[0]) nodes[0].textContent = (0, $knjAn.t)('sms_promotional_before');
            if (nodes[1]) nodes[1].textContent = (0, $knjAn.t)('sms_promotional_after');
        });
        // Terms & privacy label: "I accept the [Terms] and [Privacy Policy]."
        document.querySelectorAll('.terms-privacy-label').forEach((el)=>{
            const nodes = Array.from(el.childNodes).filter((n)=>n.nodeType === Node.TEXT_NODE);
            if (nodes[0]) nodes[0].textContent = (0, $knjAn.t)('terms_privacy_before');
            if (nodes[1]) nodes[1].textContent = (0, $knjAn.t)('terms_privacy_mid');
            if (nodes[2]) nodes[2].textContent = (0, $knjAn.t)('terms_privacy_after');
            const termsLink = el.querySelector('.terms-link');
            if (termsLink) termsLink.textContent = (0, $knjAn.t)('terms_and_conditions');
            const privacyLink = el.querySelector('.privacy-link');
            if (privacyLink) privacyLink.textContent = (0, $knjAn.t)('privacy_policy');
        });
        // Passive consent: "By continuing, you consent to receive... from [Business Name]. Msg & data rates..."
        document.querySelectorAll('.sms-consent-passive-text').forEach((el)=>{
            const nodes = Array.from(el.childNodes).filter((n)=>n.nodeType === Node.TEXT_NODE);
            if (nodes[0]) nodes[0].textContent = (0, $knjAn.t)('sms_passive_before');
            if (nodes[1]) nodes[1].textContent = (0, $knjAn.t)('sms_passive_after');
        });
    }
    $df8dbfc52b347d84$var$loadData(form.data);
    if (Object.values(form.data.procedures).length > 0) {
        (0, $cEKee.setOriginProcedures)(Object.values(form.data.procedures));
        (0, $cEKee.setProcedures)(Object.values(form.data.procedures));
    }
    const thankYouMessage = form.data.thank_you_message || form.data.appointment_channel?.thank_you_message;
    if (thankYouMessage) document.querySelector('.notify-text').innerHTML = thankYouMessage;
    if (form.data.custom_script) $df8dbfc52b347d84$var$injectScriptFromString(form.data.custom_script);
    if (form.data.thank_you_redirect_url) (0, $cEKee.setRedirectUrl)(form.data.thank_you_redirect_url);
    if (form.data.appointment_channel?.redirect_url) (0, $cEKee.setCalendarRedirectUrl)(form.data.appointment_channel.redirect_url);
    if (form.data.hide_powered_by || projectWhitelabel) document.querySelectorAll('.subFooter--4').forEach((i)=>{
        i.innerHTML = '';
    });
    // Disable the search service
    (0, $cEKee.setIsDisableSearchService)(form?.data?.disable_search_service);
    (0, $cEKee.setIsHideServiceDuration)(form?.data?.hide_service_duration ?? false);
    (0, $cEKee.setCategories)(form.data.service_categories);
    /* Check width of screen is mobile */ if ((0, $er9E0.params)('mobile')) document.querySelector('.assistant__iframe').classList.add('mobile-ver');
    /* Check width of screen is desktop */ if ((0, $er9E0.params)('desktop')) {
        document.querySelector('.assistant__iframe').classList.add('desktop-ver');
        (0, $cEKee.setIsDesktopVer)(true);
    }
    // Check if in iframe
    if ((0, $er9E0.params)('in_iframe')) (0, $cEKee.setInitUI)('embedded');
    /* Check scheduling link */ if ((0, $er9E0.params)('appointment_channel_id')) document.querySelector('.assistant__iframe').classList.add('scheduling-link');
    // Square chrome only on the PilotPractice Marketing Intro booker
    // (channel 441). Do not flatten any other widget or scheduling link.
    if (String((0, $er9E0.params)('appointment_channel_id')) === '441') document.querySelector('.assistant__iframe').classList.add('square-corners');
    /* Check scheduling link */ if ((0, $er9E0.params)('appointment_channel_for_floater')) document.querySelector('.assistant__iframe').classList.add('appointment_channel_for_floater');
    (0, $cEKee.pagesDom).push(document.querySelector('.mainMenu__container'));
    // Add icon background color
    document.querySelectorAll('.icon__background').forEach((element)=>{
        element.style.background = `${0, $cEKee.primaryColor}0f`;
    });
    if ((0, $er9E0.params)('modal-popup')) (0, $cEKee.setIsModalPopup)(true);
    const isOpen = (0, $er9E0.params)((0, $cIxq8.FULL_PAGE)) && (0, $er9E0.params)('procedure_id') && (0, $er9E0.params)('staff_id') || (0, $er9E0.params)((0, $cIxq8.APPOINTMENT_CHANNEL_ID));
    if (isOpen) {
        (0, $2XKfp.toggleLoading)(true);
        (0, $er9E0.openBookAppointment)();
    }
    if ($df8dbfc52b347d84$var$buttonTriggered) $df8dbfc52b347d84$var$openWidgetFromButtonTrigger($df8dbfc52b347d84$var$buttonTriggered);
    if ((0, $er9E0.params)((0, $cIxq8.UPLOAD_ID_PARAM))) (0, $78cae6baa635da61$export$da7b12389736c7c8)();
    else if ((0, $er9E0.params)((0, $cIxq8.EVENT_ID_PARAM))) await (0, $8Jd2Q.loadAppoinmentConfirmedLandingPage)();
    else if ((0, $er9E0.params)((0, $cIxq8.ESTIMATE_ID_PARAM))) await (0, $cf83fa47141f867b$export$ed7964ad3bf65a65)();
    else if ((0, $er9E0.params)((0, $cIxq8.BOOK_APPOINTMENT_PARAM))) {
        const leadId = (0, $er9E0.params)('lead_id');
        const signature = (0, $er9E0.params)('signature');
        const expires = (0, $er9E0.params)('expires');
        const dropoffOtpResume = (0, $er9E0.params)((0, $cIxq8.DROPOFF_RESUME_PARAM)) === 'after_otp' && leadId && signature && expires;
        if (dropoffOtpResume) try {
            const res = await (0, $cNdCr.getLeadResumeToken)(leadId, signature, expires);
            const data = res?.data ?? res;
            if (data?.access_token) (0, $cEKee.setAccessToken)(data.access_token);
            if (data?.lead) (0, $cEKee.setLeadInfo)(data.lead);
        } catch (_) {
        // Link invalid or expired; continue without auto-login
        }
        if (0, $cEKee.isModalPopup) (0, $6929ae063ef9e5f0$export$a8565b6bdf6e359c)();
        else (0, $er9E0.openBookAppointment)();
        $df8dbfc52b347d84$var$postVisitor();
        $df8dbfc52b347d84$var$loadComponents();
        $df8dbfc52b347d84$var$listeners();
    } else {
        (0, $5rwTR.handleInstantQuoteSummary)();
        $df8dbfc52b347d84$var$postVisitor();
        $df8dbfc52b347d84$var$loadComponents();
        $df8dbfc52b347d84$var$listeners();
        if ((0, $er9E0.params)((0, $cIxq8.IGNORE_IFRAME)) && (0, $er9E0.params)((0, $cIxq8.ESTIMATE))) {
            document.getElementById('instant_quote')?.click();
            document.querySelector('.providers__container .providerBack__btn').style.visibility = 'hidden';
        }
    }
    if (parent) parent.postMessage((0, $cIxq8.EVENT_MESSAGE).FINISH_LOADING_IFRAME, '*');
    (0, $4tyfr.applyDisclaimerFooters)();
};
window.addEventListener('message', ({ data: data })=>{
    if (data && typeof data === 'string' && data.startsWith('navigate')) $df8dbfc52b347d84$var$buttonTriggered = $df8dbfc52b347d84$var$extractMessageKey(data);
});
const $df8dbfc52b347d84$var$extractMessageKey = (message)=>message.replace('navigate', '').trim();
/**
 * When widget runs inside assistant.pilotpractice.com iframe, the embedding page
 * (e.g. zarrabimd.com) passes source/domain/path so we can attribute the visitor
 * to the real site instead of the iframe URL. Returns { domain, path, referrer } for the
 * embedding page when available.
 */ function $df8dbfc52b347d84$var$getEmbeddingPageAttribution() {
    const sourceParamVal = (0, $er9E0.params)('source');
    const domainParamVal = (0, $er9E0.params)('domain');
    const pathParamVal = (0, $er9E0.params)('path');
    const isAssistantIframe = /assistant\.pilotpractice\.com/i.test(window.location.hostname);
    if (!isAssistantIframe || !sourceParamVal && !(domainParamVal && pathParamVal)) return null;
    let pageUrl = null;
    if (sourceParamVal && (sourceParamVal.startsWith('http://') || sourceParamVal.startsWith('https://'))) pageUrl = sourceParamVal.split('#')[0];
    else if (domainParamVal && pathParamVal) {
        const path = pathParamVal.startsWith('/') ? pathParamVal : '/' + pathParamVal;
        const domain = domainParamVal.replace(/^https?:\/\//, '').split('/')[0];
        pageUrl = `https://${domain}${path}`;
    }
    if (!pageUrl) return null;
    try {
        const u = new URL(pageUrl);
        return {
            domain: u.hostname,
            path: u.pathname || '/',
            referrer: pageUrl
        };
    } catch (_) {
        return null;
    }
}
/** Get a query param from a URL string (e.g. referrer). Returns null if URL is invalid or param missing. */ function $df8dbfc52b347d84$var$paramFromUrl(urlString, paramName) {
    if (!urlString || typeof urlString !== 'string') return null;
    try {
        const url = new URL(urlString);
        return url.searchParams.get(paramName);
    } catch  {
        return null;
    }
}
async function $df8dbfc52b347d84$var$postVisitor() {
    const embedding = $df8dbfc52b347d84$var$getEmbeddingPageAttribution();
    let visitorPayload = {
        domain: window.location.hostname,
        path: window.location.pathname + window.location.search,
        referrer: document.referrer || ''
    };
    if (embedding) {
        visitorPayload.domain = embedding.domain;
        visitorPayload.path = embedding.path;
        visitorPayload.referrer = embedding.referrer;
    }
    const referrerUrl = visitorPayload.referrer || '';
    // Prefer current URL params, fall back to referrer (so we capture gclid/gbraid/wbraid when they're only in the referrer).
    const get = (name)=>(0, $er9E0.params)(name) || $df8dbfc52b347d84$var$paramFromUrl(referrerUrl, name);
    // Send paid_ad_click when we have click IDs OR our tracking source (google-ads-*, meta-ads-*) so number swap works for all ad visitors.
    // Include gbraid/wbraid so iOS (and other browsers that send braid instead of gclid) get captured and conversions can be sent to Google.
    const sourceVal = get('source') || '';
    const isOurAdSource = /^(google-ads-|meta-ads-)/i.test(sourceVal.trim());
    if (get('gclid') || get('fbclid') || get('gbraid') || get('wbraid') || get('oppref') || isOurAdSource) visitorPayload['paid_ad_click'] = {
        ...get('gclid') && {
            gclid: get('gclid')
        },
        ...get('fbclid') && {
            fbclid: get('fbclid')
        },
        ...get('oppref') && {
            oppref: get('oppref')
        },
        ...get('utm_medium') && {
            utm_medium: get('utm_medium')
        },
        ...get('utm_source') && {
            utm_source: get('utm_source')
        },
        ...get('utm_campaign') && {
            utm_campaign: get('utm_campaign')
        },
        ...get('utm_network') && {
            utm_network: get('utm_network')
        },
        ...get('gbraid') && {
            gbraid: get('gbraid')
        },
        ...get('wbraid') && {
            wbraid: get('wbraid')
        },
        ...sourceVal && {
            source: sourceVal
        }
    };
    const response = await (0, $iDiGD.createVisitor)(visitorPayload);
    if (response.data) {
        (0, $cEKee.setVisitorId)(response.data.id);
        window.visitor_id = response.data.id;
    }
}
function $df8dbfc52b347d84$var$loadComponents() {
    document.querySelector('.main__logo').setAttribute('src', (0, $cEKee.form).project.business_photo);
    if ((0, $cEKee.form).project.business_photo) document.querySelector('.appointment__logo').setAttribute('src', (0, $cEKee.form).project.business_photo);
    (0, $315d4aa1c7fc9672$export$6f4c428fe84a2fb6)();
    (0, $fQMeL.loadInstantQuotes)();
    (0, $1675b659b2b8ee2b$export$f416febee6ad4e0b)();
    (0, $ec621361ff91bff2$export$812c1b6681c8ea84)();
    // loadProcedures(procedures);
    // loadCategories(procedures);
    const shouldCollectPatientInfoFirst = (0, $cEKee.form)?.appointment_channel?.collect_patient_information_first_before_scheduling;
    const pros = (0, $cEKee.appointmentChannelId) && shouldCollectPatientInfoFirst ? (0, $cEKee.form)?.appointment_channel?.procedures : (0, $cEKee.procedures);
    (0, $sFKcc.loadSelectSearchProcedure)(pros);
    (0, $fJdVD.loadLocationList)();
    (0, $4707e992cabc7e60$export$1ad0e6e0e8e8da5)();
    if ((0, $cEKee.providers).length > 1) (0, $5xphE.loadProvidersDropdown)((0, $cEKee.providers));
    if ((0, $cEKee.locations).length > 0) (0, $lUSOA.loadLocationsDropdown)((0, $cEKee.locations));
    (0, $60783c4f57b11a7a$export$2d0d80238b015dab)();
}
function $df8dbfc52b347d84$var$canUserChooseStaff(hostType, staffCount) {
    switch(hostType){
        case 0, $cIxq8.HOST_TYPE_ONE_ON_ONE:
            return staffCount > 1;
        case 0, $cIxq8.HOST_TYPE_ROUND_ROBIN:
        case 0, $cIxq8.HOST_TYPE_COLLECTIVE:
            return false;
        default:
            return (0, $cEKee.form)?.appointment_channel?.visitor_can_choose_the_staff;
    }
}
function $df8dbfc52b347d84$var$getHostType() {
    return (0, $cEKee.form)?.appointment_channel?.host || (0, $cIxq8.HOST_TYPE_ONE_ON_ONE);
}
function $df8dbfc52b347d84$var$listeners() {
    // Drop-off session watch: tab hidden 15s / page unload → end session now
    // instead of waiting for the backend's 5-minute idle sweep.
    (0, $1e504a102eae1230$export$2c20d2978a5322d6)();
    (0, $er9E0.pageListeners)();
    (0, $2222087cd0364acf$export$8e55c0b1f0eddfd7)();
    (0, $cgStI.scheduleListeners)();
    (0, $56563102da8e9072$export$9448dc9a900bb387)();
    (0, $2XKfp.setLoadingColor)((0, $cEKee.primaryColor));
    if ((0, $cEKee.locations).length > 0) (0, $hGWxM.locationListeners)();
    (0, $2387e5b671afe639$export$772674902f30d131)();
    (0, $66f462f84363ba9e$export$1bf9d194e3b52021)();
    (0, $3b6e9b9ccceceef8$export$2161feb067d9b9c8)();
    // Booking-path contact prefill (URL params from marketing handoffs like
    // kloudmd.com/get-started). Must run AFTER fullNameListeners/emailListeners
    // assign the oninput validators, and must dispatch 'input' so validation
    // runs and the screen's Continue button enables. Values set via .value are
    // inert as HTML; urlPrefill sanitizes on parse.
    [
        [
            '#fullName',
            (0, $cFczh.urlPrefill).full_name
        ],
        [
            '#email',
            (0, $cFczh.urlPrefill).email
        ]
    ].forEach(([sel, val])=>{
        const el = document.querySelector(sel);
        if (el && !el.value && val) {
            el.value = val;
            el.dispatchEvent(new Event('input', {
                bubbles: true
            }));
        }
    });
    (0, $1kc6e.validateDigitsListeners)();
    (0, $048956782fe055b4$export$44f05f845b6676f2)();
    (0, $5rwTR.instantQuoteSummaryListeners)();
    (0, $bf3b5fbb0be7417c$export$862cc17a0e66eeb9)();
    (0, $cOK4N.surgicalListeners)();
    // Listen to messages from parent window
    (0, $8ENHq.bindEvent)(window, 'message', function(e) {
        let message = e.data;
        if (message && message === (0, $cIxq8.UPDATE_APPOINTMENT_CHANNEL)) (0, $1f5FT.getFormByFormId)((0, $cEKee.formId), (0, $cEKee.appointmentChannelId)).then((data)=>{
            (0, $cEKee.setForm)(data.data);
            (0, $er9E0.openBookAppointment)();
        }).catch((error)=>{});
        if (message && typeof message === 'string') {
            if (message.includes('redirect')) window.parent.location.href = message.substring(8);
            if (message.includes('navigate')) message = message.substring(8);
            switch(message){
                case (0, $cIxq8.EVENT_MESSAGE).REFRESH:
                    // Parent closes the widget bubble → REFRESH. Start the
                    // 15s drop-off grace timer (cancelled on reopen).
                    (0, $1e504a102eae1230$export$fffabf9cbd3c2d70)();
                    (0, $er9E0.refresh)();
                    break;
                case (0, $cIxq8.EVENT_MESSAGE).INSTANT_QUOTE:
                    (0, $er9E0.openInstantQuote)();
                    break;
                case (0, $cIxq8.EVENT_MESSAGE).REQUEST_CONSULT:
                    (0, $er9E0.openScheduleConsultation)();
                    break;
                case (0, $cIxq8.EVENT_MESSAGE).ASK_QUESTION:
                    (0, $er9E0.openAskQuestion)();
                    break;
                case (0, $cIxq8.EVENT_MESSAGE).TEXT_US:
                    (0, $er9E0.navigate)((0, $cIxq8.SCREEN).ASK_QUESTION);
                    break;
                case (0, $cIxq8.EVENT_MESSAGE).FINISH_LOADING:
                    (0, $2XKfp.toggleLoadingIframe)((0, $cIxq8.HIDE));
                    break;
                case (0, $cIxq8.EVENT_MESSAGE).BOOK_APPOINTMENT:
                    (0, $6929ae063ef9e5f0$export$a8565b6bdf6e359c)();
                    (0, $er9E0.openBookAppointment)();
                    break;
                case (0, $cIxq8.EVENT_MESSAGE).TOGGLE_WIDGET:
                    (0, $4tyfr.applyDisclaimerFooters)();
                    if ((0, $cEKee.appointmentChannelId) && !(0, $cEKee.shouldCollectPatientInfoFirstForWidget)) (0, $er9E0.openBookAppointment)();
                    break;
                case (0, $cIxq8.EVENT_MESSAGE).OPEN_BOOK_APPOINTMENT_FLOW:
                    (0, $er9E0.openBookAppointment)();
                    break;
                case (0, $cIxq8.EVENT_MESSAGE).WIDGET_OPEN:
                    // Widget reopened → cancel any pending drop-off timer.
                    (0, $1e504a102eae1230$export$6cc41339ab57dfd2)();
                    if (0, $cEKee.visitorId) (0, $iDiGD.updateVisitorAction)((0, $cEKee.visitorId), 'view-widget', {
                        widget_type: 'Open Assistant'
                    }).catch((error)=>{
                        console.error('Failed to track assistant widget open:', error);
                    });
                    break;
                default:
                    break;
            }
        }
    });
    /* on click Continue after select procedure */ document.querySelector('.procedureContinue__btn').addEventListener('click', async ()=>{
        const isConsultationRequest = (0, $cEKee.form).appointment_request_type === (0, $cIxq8.APPOINTMENT_REQUEST_FORM);
        if (isConsultationRequest && (0, $cEKee.form)?.is_category_enabled && ((0, $cEKee.tempLeadInfo) || (0, $cEKee.leadInfo)) && (0, $cEKee.selectedProcedures).length > 0) {
            let loaderIcon = document.querySelector('.procedureContinue__btn .loader__icon');
            try {
                document.querySelector('.procedureContinue__btn')?.classList.add('disabled');
                document.querySelector('.procedureContinue__btn .loading__wrapper')?.classList.remove('hidden');
                if (loaderIcon) loaderIcon.innerHTML = `<img src="${0, $cEKee.appUrl}/assets/icons/rolling.png" />`;
                (0, $2XKfp.toggleLoading)(true);
                const data = {
                    ...(0, $cEKee.tempLeadInfo),
                    procedures_interested_in: (0, $cEKee.selectedProcedures)
                };
                const selectedProcedureNames = (0, $cEKee.selectedProcedures).map((id)=>(0, $cEKee.procedures).find((item)=>item?.id === id)?.name).filter(Boolean);
                const serviceValue = selectedProcedureNames.join(', ');
                if (serviceValue) {
                    const lastFormSubmission = {
                        ...data.last_form_submission || {}
                    };
                    const existingFields = Array.isArray(lastFormSubmission.fields) ? lastFormSubmission.fields : [];
                    const serviceIndex = existingFields.findIndex((field)=>field?.name === 'service' || field?.label?.toLowerCase() === 'service');
                    const nextFields = [
                        ...existingFields
                    ];
                    if (serviceIndex >= 0) nextFields[serviceIndex] = {
                        ...nextFields[serviceIndex],
                        value: serviceValue
                    };
                    else nextFields.push({
                        name: 'service',
                        label: 'Service',
                        value: serviceValue,
                        placeholder: ''
                    });
                    lastFormSubmission.fields = nextFields;
                    data.last_form_submission = lastFormSubmission;
                }
                (0, $cEKee.setTempLeadInfo)(data);
                (0, $2XKfp.toggleLoading)(false);
                (0, $cEKee.setIsInstantQuote)(false);
                const ids = (0, $cEKee.form)?.appointment_channel?.staffs?.map((i)=>i.id);
                let listProvider = (0, $cEKee.providers).filter((provider)=>ids.includes(provider.id));
                if ((0, $cEKee.selectedProcedures).length > 0) {
                    let res = await (0, $3UENa.getProceduresStaffByProcedureIds)((0, $cEKee.selectedProcedures));
                    (0, $cEKee.setStaffProcedures)(res?.data?.data || []);
                    const staffProcedures = res?.data?.data || [];
                    const staffAllowedIds = new Set(staffProcedures.map((sp)=>sp.staff_id));
                    listProvider = listProvider.filter((p)=>staffAllowedIds.has(p.id));
                }
                listProvider = listProvider.filter((provider)=>provider.location_ids?.includes((0, $cEKee.locationId)));
                (0, $hprW2.loadProviderList)(listProvider);
                document.querySelector('.providers__container')?.classList?.add('provider-in-booking');
                (0, $62LVp.renderContinueBtn)();
                (0, $a5XF8.providerListeners)();
                if (0, $cEKee.appointmentChannelId) document.querySelector('.providers__container .providerContinue__btn ')?.classList?.add('hide');
                (0, $er9E0.navigate)((0, $cIxq8.SCREEN).PROVIDERS);
            // handelConsultSummaryBtn();
            } catch (error) {
                console.log(error);
                (0, $gZEOs.toastError)(error.response?.data?.message);
                (0, $2XKfp.toggleLoading)(false);
            } finally{
                setTimeout(()=>{
                    if (loaderIcon) loaderIcon.innerHTML = '<i class="ri-arrow-right-line"></i>';
                    document.querySelector('.procedureContinue__btn .loading__wrapper')?.classList.add('hidden');
                    document.querySelector('.procedureContinue__btn')?.classList.remove('disabled');
                }, 400);
            }
            return;
        }
        if (0, $cEKee.isInInstantQuote) {
            if (0, $cEKee.skipInterestPage) {
                (0, $er9E0.navigate)((0, $cIxq8.SCREEN).FULL_NAME);
                setTimeout(()=>{
                    const fullNameInput = document.getElementById('fullName');
                    if (fullNameInput !== document.activeElement) fullNameInput.focus();
                }, 500);
            } else (0, $er9E0.navigate)((0, $cIxq8.SCREEN).INTERESTS);
        } else if (0, $cEKee.isBookAppointment) {
            let loaderIcon = document.querySelector('.procedureContinue__btn .loader__icon');
            try {
                document.querySelector('.procedureContinue__btn')?.classList.add('disabled');
                document.querySelector('.procedureContinue__btn .loading__wrapper')?.classList.remove('hidden');
                if (loaderIcon) loaderIcon.innerHTML = `<img src="${0, $cEKee.appUrl}/assets/icons/rolling.png" />`;
                const hostType = $df8dbfc52b347d84$var$getHostType();
                const staffsOfAppointmentChannel = (0, $cEKee.form)?.appointment_channel?.staffs?.filter((staff)=>staff?.online_booking);
                const staffCount = staffsOfAppointmentChannel?.length || 0;
                // Auto-select soonest provider: ignore provider-first so the flow
                // routes through handleLocationPage, which skips the picker and
                // engages the "any provider" (-1) path.
                const isProviderFirst = (0, $cEKee.form)?.appointment_channel?.is_select_provider_first && !(0, $cEKee.isAutoSelectSoonestProviderEnabled)();
                const canChooseStaff = $df8dbfc52b347d84$var$canUserChooseStaff(hostType, staffCount);
                if (((0, $cEKee.staffId) || (0, $cEKee.appointmentChannelId) && canChooseStaff && (0, $cEKee.providerId)) && isProviderFirst) {
                    const foundProvider = (0, $cEKee.providers)?.find((i)=>i?.id === +(0, $cEKee.staffId));
                    const getLocationId = foundProvider?.location_ids?.includes((0, $cEKee.selectedLocation)) || foundProvider?.location_ids[0];
                    if (!(0, $cEKee.selectedLocation)) (0, $cEKee.setSelectedLocation)(getLocationId);
                    if ((0, $cEKee.appointmentChannelId) && canChooseStaff && !(0, $cEKee.providerId)) (0, $a5XF8.handleSelectProvider)(null, +(0, $cEKee.staffId) || foundProvider?.id);
                    if (canChooseStaff && (0, $cEKee.form)?.appointment_channel?.procedures?.length > 1 && !(0, $cEKee.selectedProcedures).length) {
                        const enableCategorySelection = (0, $cEKee.form)?.appointment_channel?.enable_category_selection;
                        if (enableCategorySelection) (0, $a5XF8.handleProviderContinueBtn)();
                        else {
                            (0, $8QS3m.loadCategories)((0, $cEKee.form)?.appointment_channel?.procedures);
                            (0, $d0tLC.loadProcedures)((0, $cEKee.form)?.appointment_channel?.procedures);
                            (0, $er9E0.navigate)((0, $cIxq8.SCREEN).SEE_ALL_SERVICES);
                        }
                    } else (0, $a5XF8.handleProviderContinueBtn)();
                } else {
                    if ((0, $cEKee.selectedProcedures).length > 0) {
                        let res = await (0, $3UENa.getProceduresStaffByProcedureIds)((0, $cEKee.selectedProcedures));
                        (0, $cEKee.setStaffProcedures)(res?.data?.data || []);
                    }
                    let locationId = (0, $cEKee.form)?.appointment_channel?.location?.id ?? (0, $cEKee.locations)[0]?.id;
                    if (!isProviderFirst && (0, $cEKee.selectedLocation)) locationId = (0, $cEKee.selectedLocation);
                    if ((0, $cEKee.locations)?.length === 1 || locationId) {
                        (0, $cEKee.setSelectedLocation)(locationId);
                        (0, $hGWxM.handleLocationPage)();
                    } else (0, $er9E0.navigate)((0, $cIxq8.SCREEN).LOCATIONS);
                    document.querySelector('.no-preference-provider')?.classList?.remove('hidden');
                }
            } catch (error) {
                (0, $gZEOs.toastError)(error.response?.data?.message);
            } finally{
                setTimeout(()=>{
                    if (loaderIcon) loaderIcon.innerHTML = '<i class="ri-arrow-right-line"></i>';
                    document.querySelector('.procedureContinue__btn .loading__wrapper')?.classList.add('hidden');
                    document.querySelector('.procedureContinue__btn')?.classList.remove('disabled');
                }, 400);
            }
        }
    });
}
function $df8dbfc52b347d84$var$loadData(form) {
    (0, $cEKee.setForm)(form);
    (0, $cEKee.setFormId)(form.uuid);
    (0, $cEKee.setAccessToken)(form.token);
    (0, $cEKee.setTooltip)(form.title_tooltip);
    (0, $cEKee.setPicture)(form.picture);
    (0, $cEKee.setPhoneToCall)(form.project.business_phone);
    (0, $cEKee.setWidgetOptions)(form.widget_options);
    (0, $cEKee.setFileUploadChannel)(form.file_upload_channel);
    (0, $cEKee.setProcedureSelectionType)(form?.appointment_channel?.selection_type || form.selection_type);
    (0, $cEKee.setFinancing)(form.quote_settings?.financing_terms);
    (0, $cEKee.setHidePricing)(form.quote_settings?.hide_pricing);
    (0, $cEKee.setSkipInterestPage)(!!form.quote_settings?.skip_interest_page);
    (0, $cEKee.setHideFutureSpecialsOptIn)(!!form.quote_settings?.hide_future_specials_opt_in);
    (0, $cEKee.setShowBodyAreaSelection)(form.show_body_area_selection);
    (0, $cEKee.setLocations)(form.locations);
    if (form?.hide_widget || form.hide_widget === 0) {
        /* Send `message` to the parent */ const data = {
            hide_widget: form.hide_widget,
            type: (0, $cIxq8.HIDE_WIDGET)
        };
        parent.postMessage(data, '*');
    }
    if (form?.locations && form.locations[0] && form.locations[0]?.project_id) (0, $cEKee.setProjectId)(form.locations[0].project_id);
    (0, $cEKee.setShowSubscribedToOffersOption)(form.show_subscribed_to_offers_option);
    (0, $cEKee.setA2pConsentEnabled)(form.a2p_consent_enabled ?? false);
    (0, $cEKee.setShowMaleFemalePage)(form.show_male_female_page);
    (0, $cEKee.setConsultationNonSurgicalPath)(form.consultation_non_surgical_path);
    (0, $cEKee.setBusinessName)(form.project.business_name);
    // Apply custom consult labels if configured
    if (form.consult_header_title) {
        const headerEl = document.querySelector('.requestConsult__container .title__content');
        if (headerEl) headerEl.textContent = form.consult_header_title;
    }
    if (form.consult_button_label) document.querySelectorAll('.requestConsult__btn .text, .summaryContinue__btn').forEach((el)=>{
        if (el.classList.contains('text')) el.textContent = form.consult_button_label;
        else if (el.classList.contains('summaryContinue__btn')) {
            // Preserve the loader icon inside the button
            const loader = el.querySelector('.loader__icon');
            el.textContent = form.consult_button_label + ' ';
            if (loader) el.appendChild(loader);
        }
    });
    (0, $cEKee.setInterests)([
        {
            id: 1,
            name: (0, $knjAn.t)('interest_just_curious'),
            value: 'just_curious'
        },
        {
            id: 2,
            name: (0, $knjAn.t)('interest_as_soon_as_possible'),
            value: 'immediately'
        },
        {
            id: 3,
            name: (0, $knjAn.t)('interest_few_months'),
            value: 'few_months'
        }
    ]);
    if (Object.values(form.staff)?.length > 0) {
        let staffs = form.staff ?? [];
        const sortedStaff = (staffs || []).sort((a, b)=>Number(a?.order) - Number(b?.order));
        (0, $cEKee.setProviders)(Object.values(sortedStaff));
        (0, $cEKee.setOriginProviders)(Object.values(sortedStaff));
    }
    if (form.widget_options.length > 0) {
        let widgetOptions = [];
        let widgetCustomOptions = [];
        form.widget_options.forEach(function(option) {
            switch(option.type){
                case 'instant_quote':
                    widgetOptions.push('instant_quote');
                    (0, $cEKee.setOptionNames)('instant_quote', option.name !== (0, $knjAn.tDefault)('instant_quote') ? option.name : (0, $knjAn.t)('instant_quote'));
                    (0, $cEKee.setOptionIcons)('instant_quote', option?.icon && option.icon.name);
                    break;
                case 'ask_a_question':
                    widgetOptions.push('ask_a_question');
                    (0, $cEKee.setOptionNames)('ask_a_question', option.name !== (0, $knjAn.tDefault)('ask_question') ? option.name : (0, $knjAn.t)('ask_question'));
                    (0, $cEKee.setOptionIcons)('ask_a_question', option?.icon && option.icon.name);
                    break;
                case 'call_us':
                    widgetOptions.push('call');
                    (0, $cEKee.setOptionNames)('call', option.name !== (0, $knjAn.tDefault)('call_us') ? option.name : (0, $knjAn.t)('call_us'));
                    (0, $cEKee.setOptionIcons)('call', option?.icon && option.icon.name);
                    break;
                case 'text_us':
                    widgetOptions.push('text_us');
                    (0, $cEKee.setOptionNames)('text_us', option.name !== (0, $knjAn.tDefault)('text_us') ? option.name : (0, $knjAn.t)('text_us'));
                    (0, $cEKee.setOptionIcons)('text_us', option?.icon && option.icon.name);
                    break;
                case 'schedule_consultation':
                case 'request_consultation':
                case 'book_appointment':
                    widgetOptions.push('book_appointment');
                    (0, $cEKee.setOptionNames)('book_appointment', option.name !== (0, $knjAn.tDefault)('book_appointment') ? option.name : (0, $knjAn.t)('book_appointment'));
                    (0, $cEKee.setOptionIcons)('book_appointment', option?.icon && option.icon.name);
                    break;
                case 'faqs':
                    break;
                default:
                    (0, $cEKee.setOptionNames)(`custom_option-${option.id}`, option.name);
                    (0, $cEKee.setOptionIcons)(`custom_option-${option.id}`, option?.icon && option.icon.name);
                    widgetCustomOptions.push(`custom_option-${option.id}`);
                    break;
            }
        });
        (0, $cEKee.setWebAssistantOptions)([
            ...widgetOptions,
            ...widgetCustomOptions
        ].sort((a, b)=>a.id - b.id));
    }
}
const $df8dbfc52b347d84$var$injectScriptFromString = (scriptString)=>{
    if (!scriptString) return;
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = scriptString;
    const scripts = tempDiv.querySelectorAll('script');
    scripts.forEach((script)=>{
        const scriptElement = document.createElement('script');
        if (script.src) {
            scriptElement.src = script.src;
            scriptElement.async = script.async;
        } else scriptElement.text = script.textContent;
        document.head.appendChild(scriptElement);
    });
};
function $df8dbfc52b347d84$var$openWidgetFromButtonTrigger(buttonType = "") {
    switch(buttonType){
        case (0, $cIxq8.EVENT_MESSAGE).INSTANT_QUOTE:
            (0, $er9E0.openInstantQuote)();
            break;
        case (0, $cIxq8.EVENT_MESSAGE).REQUEST_CONSULT:
            (0, $er9E0.openScheduleConsultation)();
            break;
        case (0, $cIxq8.EVENT_MESSAGE).ASK_QUESTION:
            (0, $er9E0.openAskQuestion)();
            break;
        case (0, $cIxq8.EVENT_MESSAGE).TEXT_US:
            (0, $er9E0.navigate)((0, $cIxq8.SCREEN).ASK_QUESTION);
            break;
        case (0, $cIxq8.EVENT_MESSAGE).BOOK_APPOINTMENT:
            (0, $er9E0.openBookAppointment)();
            break;
        default:
            break;
    }
}


//# sourceMappingURL=assistant.bfda380e.js.map
